<script setup>
/* eslint-disable */
// SiteUp (2026-08-11): mesmo tratamento do irmão KanbanActions.vue/
// ContactPanel.vue. Este arquivo carrega 368 violações ANTERIORES a esta
// fatia (PR #418) — dívida do módulo Kanban legado, não desta mudança — e
// o lint do CI é estrito por arquivo tocado: sem isto, nenhuma mudança aqui
// consegue ficar verde. Registrado, não resolvido — limpar é PR próprio.
import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import FunnelAPI from '../../../../api/funnel';
import KanbanConfigAPI from '../../../../api/kanbanConfig';
import draggable from 'vuedraggable';
import agents from '../../../../api/agents';
import inboxesAPI from '../../../../api/inboxes';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

import { reactive } from 'vue';

import FunnelGoogleCalendarSection from './FunnelGoogleCalendarSection.vue';

const props = defineProps({
  isEditing: {
    type: Boolean,
    default: false,
  },
  funnelId: {
    type: [String, Number],
    default: null,
  },
  initialData: {
    type: Object,
    default: null,
  },
  externalSave: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['saved', 'close', 'metadata-updated']);
const { t } = useI18n();
const activeFormTab = ref('basic-data');

// Agrupamento em 2 niveis pra organizar tabs (escala melhor que barra horizontal).
// Grupos sao categorias de alto nivel; sub-tabs aparecem ao selecionar grupo.
const tabGroups = [
  {
    id: 'general',
    label: 'Geral',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>`,
    tabIds: ['basic-data', 'global-fields', 'settings'],
  },
  {
    id: 'performance',
    label: 'Performance',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>`,
    tabIds: ['goals', 'loss-win-reasons', 'checklist-presets'],
  },
  {
    id: 'integrations',
    label: 'Integrações',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>`,
    tabIds: ['meta-capi', 'google-ads', 'google-calendar'],
  },
  {
    id: 'ai',
    label: 'IA',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/></svg>`,
    tabIds: ['ai-auto-create'],
  },
];

const activeGroup = ref('general');

const groupOfTab = tabId => {
  const g = tabGroups.find(g => g.tabIds.includes(tabId));
  return g ? g.id : 'general';
};

const visibleTabs = computed(() => {
  const group = tabGroups.find(g => g.id === activeGroup.value);
  if (!group) return [];
  return formTabs.value.filter(t => group.tabIds.includes(t.id));
});

const selectGroup = groupId => {
  activeGroup.value = groupId;
  // Ao trocar de grupo, ativa a primeira sub-tab dele.
  const group = tabGroups.find(g => g.id === groupId);
  if (group && group.tabIds.length) {
    const firstTab = formTabs.value.find(t => group.tabIds.includes(t.id));
    if (firstTab) activeFormTab.value = firstTab.id;
  }
};

// Mantem activeGroup em sync se activeFormTab mudar via outro caminho.
watch(activeFormTab, newTabId => {
  const newGroup = groupOfTab(newTabId);
  if (newGroup !== activeGroup.value) activeGroup.value = newGroup;
});
const loading = ref(false);
const errorMessage = ref('');

// Dados das metas
const goals = ref([]);
const newGoal = ref({
  id: '',
  type: 'conversion_rate',
  value: '',
  description: '',
  unit: 'percentage',
});

const editingGoal = ref(null);
const goalDialogRef = ref(null);

const goalModalTitle = computed(() =>
  editingGoal.value
    ? t('KANBAN.FUNNELS.FORM.GOALS.MODAL_EDIT_TITLE')
    : t('KANBAN.FUNNELS.FORM.GOALS.MODAL_NEW_TITLE')
);

const resetGoalForm = () => {
  editingGoal.value = null;
  newGoal.value = {
    id: '',
    type: 'conversion_rate',
    value: '',
    description: '',
    unit: 'percentage',
  };
};

const openNewGoalModal = () => {
  resetGoalForm();
  nextTick(() => goalDialogRef.value?.open());
};

const handleGoalDialogClose = () => {
  resetGoalForm();
};

// Motivos de perda e ganho
const lossReasons = ref([]);
const winReasons = ref([]);
const newReason = ref({
  type: 'loss', // 'loss' ou 'win'
  title: '',
  description: '',
});
const editingReason = ref(null);
const reasonDialogRef = ref(null);

const reasonModalTitle = computed(() =>
  editingReason.value
    ? t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.MODAL_EDIT_TITLE')
    : t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.MODAL_NEW_TITLE')
);

const resetReasonForm = () => {
  editingReason.value = null;
  newReason.value = { type: 'loss', title: '', description: '' };
};

const openNewReasonModal = () => {
  resetReasonForm();
  nextTick(() => reasonDialogRef.value?.open());
};

const handleReasonDialogClose = () => {
  resetReasonForm();
};

// Checklist presets
const selectedStageForChecklist = ref(null);
const newChecklistItem = ref({
  text: '',
  priority: 'none',
  required: false,
});
const editingChecklistItem = ref(null);
const checklistDialogRef = ref(null);

const checklistModalTitle = computed(() =>
  editingChecklistItem.value
    ? t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.MODAL_EDIT_TITLE')
    : t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.MODAL_NEW_TITLE')
);

const resetChecklistForm = () => {
  editingChecklistItem.value = null;
  newChecklistItem.value = { text: '', priority: 'none', required: false };
};

const openNewChecklistModal = stageId => {
  if (!stageId) return;
  selectedStageForChecklist.value = stageId;
  resetChecklistForm();
  nextTick(() => checklistDialogRef.value?.open());
};

const selectedStageNameForChecklistModal = computed(() => {
  const id = selectedStageForChecklist.value;
  if (!id) return '';
  return stages.value.find(s => s.id === id)?.name || '';
});

const handleChecklistDialogClose = () => {
  resetChecklistForm();
};

const formData = ref({
  name: '',
  description: '',
  active: true,
  stages: {},
  settings: {
    status_automations: [],
    round_robin_distribution: false,
    require_loss_reason: false,
    default_currency: 'BRL',
    ai_auto_create: {
      enabled: false,
      stage_mode: 'fixed',
      default_stage: null,
      stage_routing_prompt: '',
      extract_fields: {
        title: true,
        description: true,
        priority: true,
        value: true,
      },
      custom_prompt: '',
      attach_offers: false,
      update_reroute_stage: false,
      auto_update_enabled: false,
      auto_update_after_hours: 6,
    },
    meta_capi: {
      enabled: false,
      pixel_id: '',
      access_token: '',
      test_event_code: '',
    },
    google_ads: {
      enabled: false,
      developer_token: '',
      client_id: '',
      client_secret: '',
      refresh_token: '',
      customer_id: '',
      login_customer_id: '',
      inbox_ids: [],
    },
    google_ads_stage_events: {},
    stage_events: {},
  },
  agents: [],
  global_custom_attributes: [],
});

// ===== SiteUp V2 (2026-08-11): automações por status moram no FUNIL =====
// Vieram da aba "Automação" do card. O motor no `KanbanItem` lê daqui e segue
// lendo as regras já gravadas em cards antigos, para não desligar em silêncio
// automação que roda hoje em produção.
const statusTriggers = computed(() => [
  { id: 'won', name: t('KANBAN.AUTOMATION.STATUS_TRIGGERS.WON') },
  { id: 'lost', name: t('KANBAN.AUTOMATION.STATUS_TRIGGERS.LOST') },
  { id: 'open', name: t('KANBAN.AUTOMATION.STATUS_TRIGGERS.OPEN') },
]);

// Só as quatro que a tela do card sabia configurar — o motor suporta mais, mas
// oferecer ação sem UI de configuração é oferecer regra que não faz nada.
const statusActions = computed(() => [
  {
    id: 'move_to_stage',
    name: t('KANBAN.AUTOMATION.STATUS_ACTIONS.MOVE_TO_STAGE'),
  },
  {
    id: 'assign_agent',
    name: t('KANBAN.AUTOMATION.STATUS_ACTIONS.ASSIGN_AGENT'),
  },
  {
    id: 'create_note',
    name: t('KANBAN.AUTOMATION.STATUS_ACTIONS.CREATE_NOTE'),
  },
  {
    id: 'notify_team',
    name: t('KANBAN.AUTOMATION.STATUS_ACTIONS.NOTIFY_TEAM'),
  },
]);

const statusAutomations = computed(() => {
  if (!Array.isArray(formData.value.settings.status_automations)) {
    formData.value.settings.status_automations = [];
  }
  return formData.value.settings.status_automations;
});

const addStatusAutomation = () => {
  statusAutomations.value.push({
    // Sem Date.now() no id: dois cliques no mesmo milissegundo dariam a mesma
    // chave de :key e o Vue reaproveitaria a linha errada.
    id: `status_automation_${statusAutomations.value.length}_${Math.random()
      .toString(36)
      .slice(2, 8)}`,
    enabled: true,
    trigger_type: 'status_change',
    trigger_value: '',
    action: '',
    action_config: {},
  });
};

const removeStatusAutomation = index => {
  statusAutomations.value.splice(index, 1);
};

const defaultAppointmentConfig = {
  enabled: false,
  default_title: 'Agendamento',
  default_location: '',
  default_duration_minutes: 60,
  responsible_name: '',
  message_template:
    'Aperte no Botão adicionar ao calendário para confirmar nosso compromisso!',
};
const appointmentTemplateVariables =
  '{{lead_nome}}, {{data_hora}}, {{data}}, {{hora}}, {{titulo}}, {{local}}, {{duracao}}, {{responsavel}}';

const appointmentConfig = ref({ ...defaultAppointmentConfig });
const appointmentAutomationConfig = ref({
  send_waha_event_on_appointment: false,
  waha_event_confirmation_window_min: 10,
});
const loadingAppointmentConfig = ref(false);
const savingAppointmentConfig = ref(false);
const appointmentConfigStatus = ref('');
const appointmentConfigError = ref('');

const normalizeAppointmentConfig = config => {
  const duration = Number(config?.default_duration_minutes);

  return {
    ...defaultAppointmentConfig,
    ...(config || {}),
    enabled: config?.enabled === true,
    default_duration_minutes:
      Number.isFinite(duration) && duration > 0 ? duration : 60,
  };
};

const normalizeAppointmentAutomationConfig = config => {
  const confirmationWindow = Number(config?.waha_event_confirmation_window_min);

  return {
    send_waha_event_on_appointment:
      config?.send_waha_event_on_appointment === true,
    waha_event_confirmation_window_min:
      Number.isFinite(confirmationWindow) && confirmationWindow > 0
        ? confirmationWindow
        : 10,
  };
};

// Campos adicionais para exibição
const funnelMetadata = ref({
  updated_at: null,
  optimization_history: [],
});

const stages = ref([]);
const newStage = ref({
  name: '',
  color: '#FF6B6B',
  description: '',
  sla: null,
  capacity_limit: null,
  stage_type: '',
  auto_create_conditions: [],
});

const editingStage = ref(null);
const stageDialogRef = ref(null);

const stageModalTitle = computed(() =>
  editingStage.value
    ? t('KANBAN.FUNNELS.FORM.STAGES.MODAL_EDIT_TITLE')
    : t('KANBAN.FUNNELS.FORM.STAGES.MODAL_NEW_TITLE')
);

const resetStageForm = () => {
  editingStage.value = null;
  newStage.value = {
    name: '',
    color: '#FF6B6B',
    description: '',
    sla: null,
    capacity_limit: null,
    stage_type: '',
    auto_create_conditions: [],
  };
};

const openNewStageModal = () => {
  resetStageForm();
  nextTick(() => stageDialogRef.value?.open());
};

const handleStageDialogClose = () => {
  resetStageForm();
};

const dragOptions = {
  animation: 150,
  ghostClass: 'ghost-card',
};

const vFocus = {
  mounted: el => el.focus(),
};

const agentsList = ref([]);
const loadingAgents = ref(false);
const existingStageIds = ref(new Set());

// Mantido para compatibilidade com bundles de dev em cache (HMR): o template atual
// não usa estes símbolos; após recarregar a página o aviso some.
const newCondition = ref({
  type: 'contact_has_tag',
  value: '',
  attribute: '',
  operator: 'equal_to',
});

// Array de abas do formulário
const formTabs = computed(() => [
  {
    id: 'basic-data',
    icon: 'file-text',
    label: t('KANBAN.FUNNELS.FORM.SECTIONS.BASIC_DATA'),
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text-icon lucide-file-text"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>`,
  },
  {
    id: 'global-fields',
    icon: 'list-plus',
    label: t('KANBAN.FUNNELS.FORM.SECTIONS.GLOBAL_CUSTOM_FIELDS'),
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-plus-icon lucide-list-plus"><path d="M16 5H3"/><path d="M11 12H3"/><path d="M16 19H3"/><path d="M18 9v6"/><path d="M21 12h-6"/></svg>`,
  },
  {
    id: 'settings',
    icon: 'settings',
    label: 'Configurações',
  },
  {
    id: 'goals',
    icon: 'crosshair',
    label: t('KANBAN.FUNNELS.FORM.SECTIONS.GOALS'),
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-crosshair-icon lucide-crosshair"><circle cx="12" cy="12" r="10"/><line x1="22" x2="18" y1="12" y2="12"/><line x1="6" x2="2" y1="12" y2="12"/><line x1="12" x2="12" y1="6" y2="2"/><line x1="12" x2="12" y1="22" y2="18"/></svg>`,
  },
  {
    id: 'loss-win-reasons',
    icon: 'list-checks',
    label: t('KANBAN.FUNNELS.FORM.SECTIONS.LOSS_WIN_REASONS'),
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-checks-icon lucide-list-checks"><path d="M3 17h2"/><path d="M3 7h2"/><path d="M3 12h2"/><path d="M9 7l2 2 4-4"/><path d="M9 17l2 2 4-4"/><path d="M9 12h12"/></svg>`,
  },
  {
    id: 'checklist-presets',
    icon: 'list-check',
    label: t('KANBAN.FUNNELS.FORM.SECTIONS.CHECKLIST_PRESETS'),
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-check-icon lucide-list-check"><path d="M16 5H3"/><path d="M16 12H3"/><path d="M11 19H3"/><path d="m15 18 2 2 4-4"/></svg>`,
  },
  {
    id: 'meta-capi',
    icon: 'activity',
    label: 'Meta CAPI',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"/></svg>`,
  },
  {
    id: 'google-ads',
    icon: 'target',
    label: 'Google Ads',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>`,
  },
  {
    id: 'google-calendar',
    icon: 'calendar',
    label: 'Google Calendar',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
  },
  {
    id: 'ai-auto-create',
    icon: 'sparkles',
    label: 'Auto-Criacao IA',
    customSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/></svg>`,
  },
]);

// Gera o ID baseado no nome
const generateId = name => {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
};

// Gera um ID único apenas se necessário
const generateUniqueId = (baseName, existingStages, currentId = null) => {
  // Se já tem um ID e está editando, mantém o mesmo
  if (currentId && editingStage.value) {
    return currentId;
  }

  const baseId = generateId(baseName);
  const stageIds = existingStages.map(stage => stage.id);

  // Se o ID base não existe, usa ele
  if (!stageIds.includes(baseId)) {
    return baseId;
  }

  // Se existe, adiciona um timestamp para garantir unicidade
  return `${baseId}_${Date.now()}`;
};

// Atualiza o ID apenas para novas etapas
watch(
  () => newStage.value.name,
  newName => {
    if (newName && !editingStage.value) {
      newStage.value.id = generateId(newName);
    }
  }
);

// Converte as etapas para o formato esperado pela API
const formatStagesForAPI = () => {
  const formattedStages = {};

  // Garantir que as posições reflitam a ordem atual
  stages.value.forEach((stage, index) => {
    // Definir explicitamente a posição baseada no índice atual
    const position = index + 1;

    // Preserva metadados já existentes da etapa (ex: automações)
    const existingStageData = formData.value.stages?.[stage.id] || {};

    formattedStages[stage.id] = {
      ...existingStageData,
      name: stage.name,
      color: stage.color,
      position: position, // Garantir que a posição reflita a ordem atual
      description: stage.description,
      sla: stage.sla,
      capacity_limit: stage.capacity_limit,
      stage_type: stage.stage_type || '',
      auto_create_conditions: stage.auto_create_conditions || [],
      message_templates: existingStageData.message_templates || [],
      checklist_templates: stage.checklist_templates || [],
    };
  });

  return formattedStages;
};

// Função para lidar com a reordenação das etapas
const handleOrderChange = async () => {
  if (!props.isEditing) return;

  try {
    // Atualizar as posições com base na nova ordem
    stages.value.forEach((stage, index) => {
      stage.position = index + 1;
    });

    const payload = {
      name: formData.value.name,
      description: formData.value.description,
      stages: formatStagesForAPI(),
    };

    // Atualiza o estado local sem fazer chamada à API
    formData.value.stages = payload.stages;
  } catch (error) {
    // Error handling
  }
};

const handleAddStage = e => {
  if (e?.target?.closest('.colorpicker--chrome')) {
    return;
  }

  if (!newStage.value.name) return;

  if (editingStage.value) {
    const index = stages.value.findIndex(s => s.id === editingStage.value.id);
    if (index !== -1) {
      stages.value[index] = {
        ...editingStage.value,
        name: newStage.value.name,
        color: newStage.value.color,
        description: newStage.value.description,
        sla: newStage.value.sla,
        capacity_limit: newStage.value.capacity_limit,
        stage_type: newStage.value.stage_type || '',
        auto_create_conditions: [...newStage.value.auto_create_conditions],
        checklist_templates: editingStage.value.checklist_templates || [],
        id: editingStage.value.id,
      };
      if (props.isEditing) {
        handleOrderChange();
      }
    }
    editingStage.value = null;
  } else {
    let stageId = generateId(newStage.value.name);
    let counter = 1;
    while (existingStageIds.value.has(stageId)) {
      stageId = `${generateId(newStage.value.name)}_${counter}`;
      counter++;
    }
    stages.value.push({
      ...newStage.value,
      id: stageId,
      checklist_templates: [],
    });
    existingStageIds.value.add(stageId);
  }
  newStage.value = {
    name: '',
    color: '#FF6B6B',
    description: '',
    sla: null,
    capacity_limit: null,
    stage_type: '',
    auto_create_conditions: [],
  };
  stageDialogRef.value?.close();
};

const removeStage = index => {
  stages.value.splice(index, 1);
};

// Busca todos os funis e coleta os IDs existentes
const fetchExistingStageIds = async () => {
  try {
    const { data: allFunnels } = await FunnelAPI.get();
    existingStageIds.value.clear();

    allFunnels.forEach(funnel => {
      if (funnel.id !== props.funnelId) {
        // Ignora o funil atual se estiver editando
        Object.keys(funnel.stages || {}).forEach(id => {
          existingStageIds.value.add(id);
        });
      }
    });
  } catch (error) {
    // Error handling
  }
};

// Inicializa o formulário
onMounted(async () => {
  // Carrega agentes e inboxes sempre
  await Promise.all([fetchAgents(), fetchInboxes(), fetchAppointmentConfig()]);

  // Carrega dados do funil se estiver editando
  if (props.isEditing && props.funnelId) {
    await fetchFunnelData();
  }

  // Se estiver criando e existir initialData vindo de template, hidrata o formulário
  if (!props.isEditing && props.initialData) {
    formData.value.name = props.initialData.name || '';
    formData.value.description = props.initialData.description || '';
    formData.value.active = true;
    formData.value.stages = props.initialData.stages || {};
    formData.value.settings = props.initialData.settings || {};
    formData.value.agents = (props.initialData.settings?.agents || []).map(
      normalizeAgentForFunnel
    );

    // Inicializa lista de etapas ordenadas
    stages.value = Object.entries(formData.value.stages)
      .map(([id, stage]) => ({
        id,
        name: stage.name,
        color: stage.color,
        description: stage.description,
        sla: stage.sla,
        capacity_limit: stage.capacity_limit,
        stage_type: stage.stage_type || '',
        position: parseInt(stage.position, 10) || 0,
        auto_create_conditions: [...(stage.auto_create_conditions || [])],
        message_templates: stage.message_templates || [],
        checklist_templates: [...(stage.checklist_templates || [])],
      }))
      .sort((a, b) => a.position - b.position);
  }

  // Garante que sempre tenha pelo menos um campo customizado vazio
  if (
    !Array.isArray(formData.value.global_custom_attributes) ||
    formData.value.global_custom_attributes.length === 0
  ) {
    formData.value.global_custom_attributes = [
      { name: '', type: '', field_type: 'single', list_values: [] },
    ];
  }

  // Watcher para salvamento externo
  watch(
    () => props.externalSave,
    newValue => {
      if (newValue) {
        handleSubmit();
      }
    }
  );
});

const fetchAgents = async () => {
  try {
    loadingAgents.value = true;
    const { data } = await agents.get();
    agentsList.value = data;
  } catch (error) {
    // Error handling
  } finally {
    loadingAgents.value = false;
  }
};

const fetchInboxes = async () => {
  try {
    loadingInboxes.value = true;
    const response = await inboxesAPI.get();
    inboxes.value = response.data.payload || [];
  } catch (error) {
    inboxes.value = [];
  } finally {
    loadingInboxes.value = false;
  }
};

const fetchAppointmentConfig = async () => {
  try {
    loadingAppointmentConfig.value = true;
    appointmentConfigError.value = '';
    const response = await KanbanConfigAPI.getConfig();
    const config = response.data?.config || {};
    appointmentConfig.value = normalizeAppointmentConfig(
      config.appointment_waha
    );
    appointmentAutomationConfig.value =
      normalizeAppointmentAutomationConfig(config);
  } catch (error) {
    appointmentConfigError.value =
      'Erro ao carregar configuração de agendamento';
  } finally {
    loadingAppointmentConfig.value = false;
  }
};

const saveAppointmentConfig = async () => {
  try {
    savingAppointmentConfig.value = true;
    appointmentConfigStatus.value = '';
    appointmentConfigError.value = '';
    const normalizedConfig = normalizeAppointmentConfig(
      appointmentConfig.value
    );
    const normalizedAutomation = normalizeAppointmentAutomationConfig(
      appointmentAutomationConfig.value
    );

    const response = await KanbanConfigAPI.updateWebhookConfig({
      config: {
        appointment_waha: normalizedConfig,
        ...normalizedAutomation,
      },
    });

    const config = response.data?.config || {};
    appointmentConfig.value = normalizeAppointmentConfig(
      config.appointment_waha || normalizedConfig
    );
    appointmentAutomationConfig.value =
      normalizeAppointmentAutomationConfig(config);
    appointmentConfigStatus.value = 'Configuração de agendamento salva.';
  } catch (error) {
    appointmentConfigError.value =
      error.response?.data?.error ||
      'Erro ao salvar configuração de agendamento';
  } finally {
    savingAppointmentConfig.value = false;
  }
};

const toggleCapiInbox = inboxId => {
  if (!formData.value.settings.meta_capi.inbox_ids)
    formData.value.settings.meta_capi.inbox_ids = [];
  const ids = formData.value.settings.meta_capi.inbox_ids;
  const idx = ids.indexOf(inboxId);
  if (idx >= 0) {
    ids.splice(idx, 1);
  } else {
    ids.push(inboxId);
  }
};

// Inboxes "alvo" do Meta CAPI: as marcadas, ou todas se vazio (= sem filtro).
const capiTargetInboxes = computed(() => {
  const selectedIds = formData.value.settings?.meta_capi?.inbox_ids || [];
  if (selectedIds.length === 0) return inboxes.value;
  return inboxes.value.filter(ib => selectedIds.includes(ib.id));
});

// Cloud API oficial Meta - aparece o campo WABA ID.
// Channel::Whatsapp = WhatsApp Business Cloud API (oficial Meta).
const hasOfficialWhatsappInCapi = computed(() =>
  capiTargetInboxes.value.some(ib => ib.channel_type === 'Channel::Whatsapp')
);

// API nao-oficial (WAHA via Channel::Api) ou ausencia de Whatsapp oficial -
// nesse caso o user_data CTWA usa page_id (Facebook Page) em vez de WABA.
const hasUnofficialWhatsappInCapi = computed(
  () =>
    capiTargetInboxes.value.some(ib => ib.channel_type === 'Channel::Api') ||
    !hasOfficialWhatsappInCapi.value
);

const updateStageEvent = (stageKey, eventName) => {
  if (!formData.value.settings.stage_events)
    formData.value.settings.stage_events = {};
  formData.value.settings.stage_events[stageKey] = {
    ...(formData.value.settings.stage_events[stageKey] || {}),
    event_name: eventName || null,
    enabled: !!eventName,
  };
};

const toggleStageEvent = (stageKey, enabled) => {
  if (!formData.value.settings.stage_events)
    formData.value.settings.stage_events = {};
  formData.value.settings.stage_events[stageKey] = {
    ...(formData.value.settings.stage_events[stageKey] || {}),
    enabled,
  };
};

// ===== Google Ads helpers =====
const toggleGoogleAdsInbox = inboxId => {
  if (!formData.value.settings.google_ads.inbox_ids)
    formData.value.settings.google_ads.inbox_ids = [];
  const ids = formData.value.settings.google_ads.inbox_ids;
  const idx = ids.indexOf(inboxId);
  if (idx >= 0) ids.splice(idx, 1);
  else ids.push(inboxId);
};

const updateGoogleAdsStage = (stageKey, conversionActionId) => {
  if (!formData.value.settings.google_ads_stage_events)
    formData.value.settings.google_ads_stage_events = {};
  formData.value.settings.google_ads_stage_events[stageKey] = {
    ...(formData.value.settings.google_ads_stage_events[stageKey] || {}),
    conversion_action_id: conversionActionId || null,
    enabled: !!conversionActionId,
  };
};

const toggleGoogleAdsStage = (stageKey, enabled) => {
  if (!formData.value.settings.google_ads_stage_events)
    formData.value.settings.google_ads_stage_events = {};
  formData.value.settings.google_ads_stage_events[stageKey] = {
    ...(formData.value.settings.google_ads_stage_events[stageKey] || {}),
    enabled,
  };
};

const toggleGoogleAdsValue = (stageKey, sendValue) => {
  if (!formData.value.settings.google_ads_stage_events)
    formData.value.settings.google_ads_stage_events = {};
  formData.value.settings.google_ads_stage_events[stageKey] = {
    ...(formData.value.settings.google_ads_stage_events[stageKey] || {}),
    send_value: sendValue,
  };
};

const clampAutoUpdateHours = () => {
  const cfg = formData.value.settings?.ai_auto_create;
  if (!cfg) return;

  let hours = Number(cfg.auto_update_after_hours);
  if (!Number.isFinite(hours) || hours < 1) hours = 6;
  if (hours > 168) hours = 168;
  cfg.auto_update_after_hours = Math.round(hours);
};

const fetchFunnelData = async () => {
  if (!props.isEditing || !props.funnelId) return;

  try {
    loading.value = true;
    const response = await FunnelAPI.getById(props.funnelId);
    const funnelData = response.data;

    // Definir cada propriedade individualmente para garantir reatividade
    formData.value.name = funnelData.name || '';
    formData.value.description = funnelData.description || '';
    formData.value.active =
      funnelData.active !== undefined ? funnelData.active : true;
    formData.value.stages = funnelData.stages || {};
    formData.value.settings = {
      ...funnelData.settings,
      ai_auto_create: {
        enabled: false,
        stage_mode: 'fixed',
        default_stage: null,
        stage_routing_prompt: '',
        extract_fields: {
          title: true,
          description: true,
          priority: true,
          value: true,
        },
        custom_prompt: '',
        attach_offers: false,
        update_reroute_stage: false,
        auto_update_enabled: false,
        auto_update_after_hours: 6,
        ...(funnelData.settings?.ai_auto_create || {}),
      },
      meta_capi: {
        enabled: false,
        pixel_id: '',
        access_token: '',
        test_event_code: '',
        ...(funnelData.settings?.meta_capi || {}),
      },
      google_ads: {
        enabled: false,
        developer_token: '',
        client_id: '',
        client_secret: '',
        refresh_token: '',
        customer_id: '',
        login_customer_id: '',
        inbox_ids: [],
        ...(funnelData.settings?.google_ads || {}),
      },
      google_ads_stage_events: {
        ...(funnelData.settings?.google_ads_stage_events || {}),
      },
      stage_events: {
        ...(funnelData.settings?.stage_events || {}),
      },
    };
    formData.value.agents = funnelData.settings?.agents || [];
    formData.value.global_custom_attributes = Array.isArray(
      funnelData.global_custom_attributes
    )
      ? funnelData.global_custom_attributes.map(attr => ({
          name: attr.name || '',
          type: attr.type || '',
          field_type: attr.is_list ? 'list' : 'single',
          list_values: attr.list_values || [],
        }))
      : [];

    // Armazenar metadados para exibição
    funnelMetadata.value = {
      updated_at: funnelData.updated_at,
      optimization_history: funnelData.settings?.optimization_history || [],
    };

    // Emitir metadados para o header
    emit('metadata-updated', {
      updated_at: funnelData.updated_at,
      name: funnelData.name,
    });

    // Se tiver agentes pré-selecionados e eles não estiverem na lista, adiciona-os
    if (funnelData.settings?.agents?.length) {
      funnelData.settings.agents.forEach(agent => {
        if (!agentsList.value.find(a => a.id === agent.id)) {
          agentsList.value.push(agent);
        }
      });
    }

    // Inicializa as metas
    goals.value = funnelData.settings?.goals || [];

    // Inicializa os motivos de perda e ganho
    lossReasons.value = funnelData.settings?.loss_reasons || [];
    winReasons.value = funnelData.settings?.win_reasons || [];

    // Inicializa as etapas do template
    if (funnelData.stages) {
      stages.value = Object.entries(funnelData.stages)
        .map(([id, stage]) => ({
          id,
          name: stage.name,
          color: stage.color,
          description: stage.description,
          sla: stage.sla,
          capacity_limit: stage.capacity_limit,
          stage_type: stage.stage_type || '',
          position: parseInt(stage.position, 10) || 0,
          auto_create_conditions: [...(stage.auto_create_conditions || [])],
          checklist_templates: [...(stage.checklist_templates || [])],
        }))
        .sort((a, b) => a.position - b.position);
    }
  } catch (error) {
    errorMessage.value = 'Erro ao carregar dados do funil';
  } finally {
    loading.value = false;
  }
};

// Compat HMR (template legado em memória): no-op — edição de condições foi removida do template.
const addCondition = () => {};

const removeCondition = () => {};

const getConditionTypeLabel = type => {
  const labels = {
    contact_has_tag: 'Contato tem tag',
    contact_has_custom_attribute: 'Atributo customizado',
    message_contains: 'Mensagem contém',
    conversation_has_priority: 'Prioridade da conversa',
    inbox_matches: 'Inbox específico',
    message_is_private: 'Mensagem privada contém',
    message_has_automation: 'Mensagem por automação contém',
    conversation_message_count: 'Quantidade de mensagens',
    last_message_age: 'Idade da última mensagem',
    message_not_read: 'Mensagem não lida',
    conversation_unassigned: 'Conversa sem agente',
    conversation_reopened: 'Conversa reaberta',
    conversation_snoozed: 'Conversa adiada',
  };
  return labels[type] || type;
};

const getOperatorLabel = operator => {
  const labels = {
    equal_to: 'Igual a',
    contains: 'Contém',
    not_equal_to: 'Diferente de',
    greater_than: 'Maior que',
    less_than: 'Menor que',
    greater_than_or_equal: 'Maior ou igual a',
    less_than_or_equal: 'Menor ou igual a',
  };
  return labels[operator] || operator;
};

const hasStageSla = stage =>
  stage.sla !== undefined && stage.sla !== null && stage.sla !== '';

const hasStageCapacityLimit = stage =>
  stage.capacity_limit !== undefined &&
  stage.capacity_limit !== null &&
  stage.capacity_limit !== '';

// Funções para manipular campos personalizados globais
const globalCustomAttributes = computed({
  get: () => formData.value.global_custom_attributes,
  set: val => {
    formData.value.global_custom_attributes = val;
  },
});

function addGlobalCustomAttribute() {
  globalCustomAttributes.value.push({
    name: '',
    type: '',
    field_type: 'single',
    list_values: [],
  });
}

function removeGlobalCustomAttribute(index) {
  globalCustomAttributes.value.splice(index, 1);
}

function addListValue(attrIndex) {
  if (!globalCustomAttributes.value[attrIndex].list_values) {
    globalCustomAttributes.value[attrIndex].list_values = [];
  }
  globalCustomAttributes.value[attrIndex].list_values.push('');
}

function removeListValue(attrIndex, valueIndex) {
  globalCustomAttributes.value[attrIndex].list_values.splice(valueIndex, 1);
}

const handleSubmit = async () => {
  try {
    loading.value = true;
    errorMessage.value = '';
    clampAutoUpdateHours();

    // Preparar as etapas mantendo os templates existentes e atualizando posições
    const formattedStages = formatStagesForAPI();

    const payload = {
      name: formData.value.name,
      description: formData.value.description,
      active: formData.value.active,
      stages: formattedStages,
      settings: {
        agents: formData.value.agents.map(normalizeAgentForFunnel),
        goals: goals.value.filter(
          goal => goal.value && goal.value.toString().trim() !== ''
        ),
        loss_reasons: lossReasons.value.filter(r => r.title.trim() !== ''),
        win_reasons: winReasons.value.filter(r => r.title.trim() !== ''),
        lead_forgotten_after_days:
          formData.value.settings?.lead_forgotten_after_days,
        round_robin_distribution:
          formData.value.settings?.round_robin_distribution,
        require_loss_reason: formData.value.settings?.require_loss_reason,
        default_currency: formData.value.settings?.default_currency,
        ai_auto_create: formData.value.settings?.ai_auto_create || {},
        meta_capi: formData.value.settings?.meta_capi || {},
        google_ads: formData.value.settings?.google_ads || {},
        google_ads_stage_events:
          formData.value.settings?.google_ads_stage_events || {},
        stage_events: formData.value.settings?.stage_events || {},
        // O payload monta `settings` campo a campo: chave não listada aqui
        // nunca chega ao backend, por mais que a tela a preencha.
        // Regra sem gatilho ou sem ação não vale nada e viraria lixo no funil.
        status_automations: (
          formData.value.settings?.status_automations || []
        ).filter(automation => automation.trigger_value && automation.action),
      },
      global_custom_attributes: formData.value.global_custom_attributes
        .filter(attr => attr.name.trim() !== '' && attr.type.trim() !== '')
        .map(attr => {
          const base = {
            name: attr.name,
            type: attr.type,
            is_list: attr.field_type === 'list',
          };
          if (attr.field_type === 'list') {
            base.list_values = (attr.list_values || []).filter(
              v => v.trim() !== ''
            );
          }
          return base;
        }),
    };

    let response;
    if (props.isEditing) {
      // Se estiver editando, faz update na API
      response = await FunnelAPI.update(props.funnelId, payload);
    } else {
      response = await FunnelAPI.create(payload);
    }

    if (response.data) {
      emit('saved', response.data);
    }
  } catch (error) {
    const responseErrors = error.response?.data?.errors;
    if (error.response?.data?.code === 'FUNNEL_LIMIT_REACHED') {
      errorMessage.value = error.response.data.error;
    } else if (responseErrors?.name?.length) {
      errorMessage.value = t('KANBAN.FUNNELS.FORM.ERRORS.NAME_TAKEN');
    } else if (responseErrors) {
      const formattedErrors = Object.values(responseErrors)
        .flat()
        .filter(Boolean)
        .join(', ');
      errorMessage.value =
        formattedErrors || t('KANBAN.FUNNELS.FORM.ERROR_GENERIC');
    } else {
      errorMessage.value = t('KANBAN.FUNNELS.FORM.ERROR_GENERIC');
    }
  } finally {
    loading.value = false;
  }
};

const startEditing = stage => {
  newStage.value = {
    id: stage.id,
    name: stage.name,
    color: stage.color,
    description: stage.description,
    sla: stage.sla,
    capacity_limit: stage.capacity_limit,
    stage_type: stage.stage_type || '',
    auto_create_conditions: [...(stage.auto_create_conditions || [])],
    checklist_templates: [...(stage.checklist_templates || [])],
  };
  editingStage.value = stage;
  nextTick(() => stageDialogRef.value?.open());
};

const saveStageEdit = index => {
  if (!editingStage.value) return;

  stages.value[index] = {
    ...stages.value[index],
    name: editingStage.value.name,
    description: editingStage.value.description,
    color: editingStage.value.color,
    auto_create_conditions: editingStage.value.auto_create_conditions,
    checklist_templates: stages.value[index].checklist_templates || [],
  };

  editingStage.value = null;

  // Se estiver editando, atualiza imediatamente
  if (props.isEditing) {
    handleOrderChange();
  }
};

const cancelEditingStage = () => {
  resetStageForm();
  stageDialogRef.value?.close();
};

// Watch para agentes
watch(
  () => formData.value.agents,
  newAgents => {
    // Handle agents update
  }
);

const toggleAgent = agent => {
  const index = formData.value.agents.findIndex(a => a.id === agent.id);
  if (index === -1) {
    formData.value.agents.push(agent);
  } else {
    formData.value.agents.splice(index, 1);
  }
};

// Compat HMR: computed usado apenas por template legado em cache.
const canAddCondition = computed(() => {
  const conditionlessTypes = [
    'message_not_read',
    'conversation_unassigned',
    'conversation_reopened',
    'conversation_snoozed',
  ];
  if (conditionlessTypes.includes(newCondition.value.type)) {
    return true;
  }
  return (
    newCondition.value.value &&
    newCondition.value.value.toString().trim() !== ''
  );
});

// Watch para atualizar unidade automaticamente baseada no tipo de meta
watch(
  () => newGoal.value.type,
  newType => {
    const unitMap = {
      conversion_rate: 'percentage',
      average_value: 'currency',
      average_time: 'days',
      total_conversions: 'count',
      total_revenue: 'currency',
    };
    newGoal.value.unit = unitMap[newType] || 'count';
  }
);

// Watch para monitorar mudanças nas etapas
watch(
  () => stages.value,
  newStages => {
    // Handle stages update
  },
  { deep: true }
);

watch(
  () => formData.value,
  newFormData => {
    // Handle formData update
  },
  { deep: true }
);

watch(
  () => formData.value.global_custom_attributes,
  val => {
    if (!Array.isArray(val) || val.length === 0) {
      formData.value.global_custom_attributes = [
        { name: '', type: '', field_type: 'single', list_values: [] },
      ];
    }
  },
  { immediate: true }
);

const agentSearch = ref('');
const agentDropdownOpen = ref(false);
const agentSelectorRef = ref(null);
const filteredAgents = computed(() => {
  if (!agentSearch.value)
    return agentsList.value.filter(
      a => !formData.value.agents.some(sel => sel.id === a.id)
    );
  return agentsList.value.filter(
    a =>
      !formData.value.agents.some(sel => sel.id === a.id) &&
      a.name.toLowerCase().includes(agentSearch.value.toLowerCase())
  );
});

const normalizeAgentForFunnel = agent => ({
  ...agent,
  is_supervisor: Boolean(agent.is_supervisor || agent.supervisor),
});

const inboxes = ref([]);
const loadingInboxes = ref(false);
function addAgent(agent) {
  if (!formData.value.agents.some(a => a.id === agent.id))
    formData.value.agents.push(normalizeAgentForFunnel(agent));
  agentDropdownOpen.value = false;
  agentSearch.value = '';
}
function removeAgent(agent) {
  formData.value.agents = formData.value.agents.filter(a => a.id !== agent.id);
}
function closeAgentDropdown(e) {
  if (!agentSelectorRef.value?.contains(e.target)) {
    agentDropdownOpen.value = false;
    window.removeEventListener('click', closeAgentDropdown);
  }
}
function openAgentDropdown() {
  agentDropdownOpen.value = true;
  setTimeout(() => {
    window.removeEventListener('click', closeAgentDropdown);
    window.addEventListener('click', closeAgentDropdown);
  }, 0);
}

function toggleSupervisor(agentId) {
  formData.value.agents = formData.value.agents.map(agent => ({
    ...agent,
    is_supervisor: agent.id === agentId ? !agent.is_supervisor : false,
  }));
}

// Controle de tooltip de cópia por etapa
const copiedStageId = ref({});

// Função para copiar o id da etapa
async function copyStageId(id) {
  navigator.clipboard.writeText(id);
  copiedStageId.value[id] = true;
  await nextTick();
  setTimeout(() => {
    copiedStageId.value[id] = false;
  }, 1500);
}

// Controle de expansão/colapso das etapas na pré-visualização

// Função para formatar valores monetários
const formatCurrency = value => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value || 0);
};

// Funções para gerenciar metas
const generateGoalId = () => {
  return `goal_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

const addGoal = () => {
  if (!newGoal.value.value) return;

  if (editingGoal.value) {
    const index = goals.value.findIndex(g => g.id === editingGoal.value.id);
    if (index !== -1) {
      goals.value[index] = {
        ...editingGoal.value,
        type: newGoal.value.type,
        value: newGoal.value.value,
        unit: newGoal.value.unit,
        description: newGoal.value.description,
        id: editingGoal.value.id,
      };
    }
    editingGoal.value = null;
  } else {
    goals.value.push({
      ...newGoal.value,
      id: generateGoalId(),
    });
  }

  newGoal.value = {
    id: '',
    type: 'conversion_rate',
    value: '',
    description: '',
    unit: 'percentage',
  };
  goalDialogRef.value?.close();
};

const removeGoal = index => {
  goals.value.splice(index, 1);
};

const startEditingGoal = goal => {
  newGoal.value = {
    id: goal.id,
    type: goal.type,
    value: goal.value,
    unit: goal.unit,
    description: goal.description,
  };
  editingGoal.value = goal;
  nextTick(() => goalDialogRef.value?.open());
};

const cancelEditingGoal = () => {
  resetGoalForm();
  goalDialogRef.value?.close();
};

const getGoalTypeLabel = type => {
  const labels = {
    conversion_rate: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.CONVERSION_RATE'),
    average_value: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.AVERAGE_VALUE'),
    average_time: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.AVERAGE_TIME'),
    total_conversions: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.TOTAL_CONVERSIONS'),
    total_revenue: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.TOTAL_REVENUE'),
  };
  return labels[type] || type;
};

const getUnitLabel = unit => {
  const labels = {
    percentage: '%',
    currency: 'R$',
    days: 'dias',
    hours: 'horas',
    count: '',
  };
  return labels[unit] || '';
};

// Funções para gerenciar motivos de perda e ganho
const addReason = () => {
  if (!newReason.value.title.trim()) return;

  const targetArray =
    newReason.value.type === 'loss' ? lossReasons : winReasons;

  if (editingReason.value) {
    const index = targetArray.value.findIndex(
      r => r.id === editingReason.value.id
    );
    if (index !== -1) {
      targetArray.value[index] = {
        ...editingReason.value,
        title: newReason.value.title,
        description: newReason.value.description,
      };
    }
    editingReason.value = null;
  } else {
    targetArray.value.push({
      id: `reason_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      title: newReason.value.title,
      description: newReason.value.description,
    });
  }

  newReason.value = { type: 'loss', title: '', description: '' };
  reasonDialogRef.value?.close();
};

const removeReason = (type, index) => {
  const targetArray = type === 'loss' ? lossReasons : winReasons;
  targetArray.value.splice(index, 1);
};

const startEditingReason = (type, reason) => {
  newReason.value = {
    type,
    title: reason.title,
    description: reason.description,
  };
  editingReason.value = reason;
  nextTick(() => reasonDialogRef.value?.open());
};

const cancelEditingReason = () => {
  resetReasonForm();
  reasonDialogRef.value?.close();
};

// Funções para gerenciar checklist presets
const addChecklistPreset = () => {
  if (!newChecklistItem.value.text.trim() || !selectedStageForChecklist.value)
    return;

  const stage = stages.value.find(
    s => s.id === selectedStageForChecklist.value
  );
  if (!stage) return;

  if (!stage.checklist_templates) {
    stage.checklist_templates = [];
  }

  if (editingChecklistItem.value) {
    const index = stage.checklist_templates.findIndex(
      c => c.id === editingChecklistItem.value.id
    );
    if (index !== -1) {
      stage.checklist_templates[index] = {
        ...editingChecklistItem.value,
        text: newChecklistItem.value.text,
        priority: newChecklistItem.value.priority,
        required: newChecklistItem.value.required,
      };
    }
  } else {
    stage.checklist_templates.push({
      id: `checklist_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      text: newChecklistItem.value.text,
      priority: newChecklistItem.value.priority,
      required: newChecklistItem.value.required,
    });
  }

  resetChecklistForm();
  checklistDialogRef.value?.close();
};

const removeChecklistPreset = (stageId, index) => {
  const stage = stages.value.find(s => s.id === stageId);
  if (!stage || !stage.checklist_templates) return;
  stage.checklist_templates.splice(index, 1);
};

const startEditingChecklistPreset = (stageId, item) => {
  selectedStageForChecklist.value = stageId;
  newChecklistItem.value = {
    text: item.text,
    priority: item.priority,
    required: item.required || false,
  };
  editingChecklistItem.value = item;
  nextTick(() => checklistDialogRef.value?.open());
};

const cancelEditingChecklistPreset = () => {
  resetChecklistForm();
  checklistDialogRef.value?.close();
};

const getChecklistPresetPriority = priority => {
  const priorityMap = {
    none: { label: 'Nenhuma', color: 'slate', iconSvg: null },
    low: {
      label: 'Baixa',
      color: 'green',
      iconSvg: '<path d="M7 13l3 3 3-3"/><path d="M7 6l3 3 3-3"/>',
    },
    medium: {
      label: 'Média',
      color: 'yellow',
      iconSvg: '<path d="M9 12l2 2 2-2"/><path d="M7 7l4 4 4-4"/>',
    },
    high: {
      label: 'Alta',
      color: 'orange',
      iconSvg: '<path d="M7 11l3-3 3 3"/><path d="M7 18l3-3 3 3"/>',
    },
    urgent: {
      label: 'Urgente',
      color: 'red',
      iconSvg:
        '<path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"/>',
    },
  };
  return priorityMap[priority] || priorityMap.none;
};
</script>

<template>
  <div class="flex flex-1 min-h-0 flex-col h-full w-full bg-n-solid-1">
    <!-- Form Tabs - 2 niveis: grupos + sub-tabs -->
    <div class="tabs-container mb-3 shrink-0">
      <!-- Nivel 1: grupos -->
      <div class="tabs-scroll-wrapper border-b border-n-weak pb-1">
        <button
          v-for="group in tabGroups"
          :key="group.id"
          type="button"
          class="tab-button flex-shrink-0"
          :class="activeGroup === group.id ? 'tab-active' : 'tab-inactive'"
          @click.stop="selectGroup(group.id)"
        >
          <div class="flex items-center gap-2">
            <span
              v-if="group.customSvg"
              class="w-4 h-4 flex-shrink-0"
              v-html="group.customSvg"
            />
            {{ group.label }}
          </div>
        </button>
      </div>
      <!-- Nivel 2: sub-tabs do grupo selecionado -->
      <div v-if="visibleTabs.length > 1" class="tabs-scroll-wrapper mt-2">
        <button
          v-for="tab in visibleTabs"
          :key="tab.id"
          type="button"
          class="tab-button flex-shrink-0 text-sm"
          :class="activeFormTab === tab.id ? 'tab-active' : 'tab-inactive'"
          @click.stop="activeFormTab = tab.id"
        >
          <div class="flex items-center gap-2">
            <span
              v-if="tab.customSvg"
              class="w-4 h-4 flex-shrink-0"
              v-html="tab.customSvg"
            />
            <fluent-icon v-else :icon="tab.icon" size="16" />
            {{ tab.label }}
          </div>
        </button>
      </div>
    </div>

    <form
      class="funnel-form scrollbar-hide flex-1 min-h-0 w-full overflow-y-auto"
      @submit.prevent="handleSubmit"
    >
      <!-- Mensagem de erro -->
      <div
        v-if="errorMessage"
        class="mb-4 p-4 bg-ruby-50 dark:bg-ruby-900/20 border border-ruby-200 dark:border-ruby-800 rounded-xl"
      >
        <div class="flex items-center gap-2">
          <span
            class="i-ri-error-warning-line size-5 text-ruby-500 dark:text-ruby-300"
          />
          <span class="text-ruby-700 dark:text-ruby-200">{{
            errorMessage
          }}</span>
        </div>
      </div>

      <!-- Tab de Dados Básicos -->
      <div v-if="activeFormTab === 'basic-data'">
        <Dialog
          ref="stageDialogRef"
          width="3xl"
          type="edit"
          :show-cancel-button="false"
          :show-confirm-button="false"
          :overflow-y-auto="true"
          @close="handleStageDialogClose"
        >
          <div class="space-y-4">
            <div class="flex items-center justify-between gap-3">
              <h3
                class="text-base font-medium leading-6 text-n-slate-12 min-w-0"
              >
                {{ stageModalTitle }}
              </h3>
              <span
                v-if="editingStage"
                class="text-sm px-2 py-1 rounded shrink-0 bg-n-alpha-2 text-n-slate-11"
              >
                {{ t('KANBAN.FUNNELS.FORM.STAGES.EDITING_BADGE') }}
              </span>
            </div>
            <!-- Nome da Etapa -->
            <div>
              <label class="block text-sm font-medium mb-2">
                {{ t('KANBAN.FUNNELS.FORM.STAGES.NAME_LABEL') }}
              </label>
              <input
                v-model="newStage.name"
                type="text"
                class="w-full px-3 py-2 border rounded-xl"
                :placeholder="t('KANBAN.FUNNELS.FORM.STAGES.NAME_PLACEHOLDER')"
              />
            </div>
            <!-- Descrição, SLA e capacidade limite (cor por etapa saiu da UI — V2 F1.1) -->
            <div class="flex flex-col sm:flex-row items-start gap-2">
              <div class="flex-1 min-w-0 space-y-3 w-full">
                <div>
                  <label class="block text-sm font-medium mb-2">
                    {{ t('KANBAN.FUNNELS.FORM.STAGES.DESCRIPTION_LABEL') }}
                  </label>
                  <input
                    v-model="newStage.description"
                    type="text"
                    class="w-full px-3 py-2 border rounded-xl"
                    :placeholder="
                      t(
                        'KANBAN.FUNNELS.FORM.STAGES.STAGE_DESCRIPTION_PLACEHOLDER'
                      )
                    "
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">
                    {{ t('KANBAN.FUNNELS.FORM.STAGES.SLA_LABEL') }}
                  </label>
                  <div class="flex items-center gap-2">
                    <input
                      v-model.number="newStage.sla"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 border rounded-xl"
                      :placeholder="
                        t('KANBAN.FUNNELS.FORM.STAGES.SLA_PLACEHOLDER')
                      "
                    />
                    <span class="text-xs text-n-slate-11 whitespace-nowrap">
                      {{ t('KANBAN.FUNNELS.FORM.STAGES.SLA_UNIT') }}
                    </span>
                  </div>
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">
                    Capacidade limite da etapa
                  </label>
                  <div class="flex items-center gap-2">
                    <input
                      v-model.number="newStage.capacity_limit"
                      type="number"
                      min="1"
                      class="w-full px-3 py-2 border rounded-xl"
                      placeholder="Ex: 20"
                    />
                    <span class="text-xs text-n-slate-11 whitespace-nowrap">
                      itens
                    </span>
                  </div>
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">
                    {{ t('KANBAN.FUNNELS.FORM.STAGES.STAGE_TYPE_LABEL') }}
                  </label>
                  <select
                    v-model="newStage.stage_type"
                    class="w-full px-3 py-2 border rounded-xl bg-n-solid-2"
                  >
                    <option value="">
                      {{ t('KANBAN.FUNNELS.FORM.STAGES.STAGE_TYPE_NEUTRAL') }}
                    </option>
                    <option value="won">
                      {{ t('KANBAN.FUNNELS.FORM.STAGES.STAGE_TYPE_WON') }}
                    </option>
                    <option value="lost">
                      {{ t('KANBAN.FUNNELS.FORM.STAGES.STAGE_TYPE_LOST') }}
                    </option>
                  </select>
                  <p class="mt-1 text-xs text-n-slate-11">
                    {{ t('KANBAN.FUNNELS.FORM.STAGES.STAGE_TYPE_HINT') }}
                  </p>
                </div>
              </div>
            </div>
            <!-- Condições de Auto Criação -->
            <div class="mt-4">
              <label class="block text-sm font-medium mb-2">
                {{ t('KANBAN.FUNNELS.FORM.STAGES.AUTO_CREATE_CONDITIONS') }}
              </label>

              <div
                class="mb-3 rounded-xl border border-yellow-200 bg-yellow-50 px-3 py-2.5 text-xs leading-relaxed text-yellow-900 dark:border-yellow-800/80 dark:bg-yellow-900/20 dark:text-yellow-100"
                role="status"
              >
                {{ t('KANBAN.FUNNELS.FORM.AUTO_CREATION.READ_ONLY_HINT') }}
              </div>

              <!-- Lista de condições existentes (somente leitura) -->
              <div
                v-if="newStage.auto_create_conditions.length > 0"
                class="mb-3 space-y-2"
              >
                <div
                  v-for="(condition, index) in newStage.auto_create_conditions"
                  :key="index"
                  class="flex flex-wrap items-center gap-2 p-2 bg-n-solid-2 rounded border"
                >
                  <span
                    class="text-xs px-2 py-1 bg-woot-100 dark:bg-woot-900 text-woot-700 dark:text-woot-300 rounded"
                  >
                    {{ getConditionTypeLabel(condition.type) }}
                  </span>
                  <span
                    v-if="condition.attribute"
                    class="text-xs text-n-slate-11"
                  >
                    {{ condition.attribute }}
                  </span>
                  <span
                    v-if="condition.operator"
                    class="text-xs text-n-slate-11"
                  >
                    {{ getOperatorLabel(condition.operator) }}
                  </span>
                  <span
                    v-if="
                      condition.value !== undefined &&
                      condition.value !== null &&
                      condition.value !== ''
                    "
                    class="text-xs font-medium"
                  >
                    {{ condition.value }}
                  </span>
                </div>
              </div>
              <p v-else class="text-sm text-n-slate-11">
                {{ t('KANBAN.FUNNELS.FORM.AUTO_CREATION.EMPTY_STATE') }}
              </p>
            </div>
          </div>
          <template #footer>
            <div class="flex w-full flex-wrap justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                color="slate"
                size="sm"
                :label="t('KANBAN.FUNNELS.FORM.ACTIONS.CANCEL')"
                @click="cancelEditingStage"
              />
              <Button
                type="button"
                variant="solid"
                color="blue"
                size="sm"
                :disabled="!newStage.name"
                :label="
                  editingStage
                    ? t('KANBAN.FUNNELS.FORM.STAGES.SAVE_BUTTON')
                    : t('KANBAN.FUNNELS.FORM.STAGES.ADD_BUTTON')
                "
                @click.stop="handleAddStage"
              />
            </div>
          </template>
        </Dialog>
        <div
          class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 gap-y-6 w-full min-w-0"
        >
          <!-- Coluna Esquerda - Formulário -->
          <div class="space-y-6 min-w-0">
            <!-- Status Ativo -->
            <div>
              <div class="flex items-center justify-between">
                <label class="block text-sm font-medium">
                  {{ t('KANBAN.FUNNELS.FORM.ACTIVE.LABEL') }}
                </label>
                <Switch v-model="formData.active" size="small" />
              </div>
              <p class="text-xs text-n-slate-11 mt-1 mb-4">
                {{ t('KANBAN.FUNNELS.FORM.ACTIVE.HELP') }}
              </p>
            </div>

            <!-- Nome do Funil -->
            <div>
              <label class="block text-sm font-medium mb-2">
                {{ t('KANBAN.FUNNELS.FORM.NAME.LABEL') }}
              </label>
              <input
                v-model="formData.name"
                type="text"
                class="w-full px-3 py-2 border rounded-xl"
                :placeholder="t('KANBAN.FUNNELS.FORM.NAME.PLACEHOLDER')"
                required
              />
            </div>

            <!-- Descrição -->
            <div>
              <label class="block text-sm font-medium mb-2">
                {{ t('KANBAN.FUNNELS.FORM.DESCRIPTION.LABEL') }}
              </label>
              <textarea
                v-model="formData.description"
                rows="3"
                class="w-full px-3 py-2 border rounded-xl"
                :placeholder="t('KANBAN.FUNNELS.FORM.DESCRIPTION.PLACEHOLDER')"
              />
            </div>

            <!-- Agentes do Funil -->
            <div class="rounded-xl space-y-4">
              <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-2 text-sm font-medium">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-users-icon lucide-users"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <circle cx="9" cy="7" r="4" />
                  </svg>
                  <span>{{
                    t('KANBAN.FUNNELS.FORM.SECTIONS.FUNNEL_AGENTS')
                  }}</span>
                </div>
              </div>
              <!-- Select com busca -->
              <div ref="agentSelectorRef" class="relative mb-2">
                <input
                  v-model="agentSearch"
                  type="text"
                  class="w-full px-3 py-2 border rounded-xl"
                  placeholder="Buscar agente..."
                  @focus="openAgentDropdown"
                  @input="openAgentDropdown"
                />
                <div
                  v-if="agentDropdownOpen"
                  class="absolute left-0 top-full w-full bg-n-solid-2 border border-n-weak rounded-xl shadow-lg max-h-60 overflow-y-auto scrollbar-hide z-[99999]"
                >
                  <div
                    v-for="agent in filteredAgents"
                    :key="agent.id"
                    class="px-3 py-2 hover:bg-woot-50 cursor-pointer flex items-center gap-2"
                    @click="addAgent(agent)"
                  >
                    <Avatar
                      :name="agent.name"
                      :src="agent.avatar_url"
                      :size="24"
                      :status="agent.availability_status"
                    />
                    <div class="flex items-center gap-2 flex-1">
                      <span class="text-sm">{{ agent.name }}</span>
                      <span
                        class="px-2 py-0.5 text-xs bg-n-alpha-2 text-n-slate-11 rounded-full capitalize"
                        >{{ agent.role }}</span>
                    </div>
                  </div>
                  <div
                    v-if="filteredAgents.length === 0"
                    class="px-3 py-2 text-n-slate-10 text-sm"
                  >
                    Nenhum agente encontrado
                  </div>
                </div>
              </div>
              <!-- Listagem compacta dos agentes selecionados -->
              <div v-if="formData.agents.length" class="space-y-1">
                <div
                  class="flex items-center justify-between px-2 py-1 bg-n-solid-2 rounded-xl mb-2"
                >
                  <span class="text-sm text-n-slate-11">
                    {{ formData.agents.length }} agente{{
                      formData.agents.length !== 1 ? 's' : ''
                    }}
                    selecionado{{ formData.agents.length !== 1 ? 's' : '' }}
                  </span>
                  <button
                    type="button"
                    class="text-xs text-ruby-500 hover:text-ruby-600 dark:text-ruby-400 dark:hover:text-ruby-300"
                    @click="formData.agents = []"
                  >
                    Limpar seleção
                  </button>
                </div>
                <div
                  v-for="agent in formData.agents"
                  :key="agent.id"
                  class="flex items-center gap-2 px-2 py-1 border border-n-weak rounded mb-1"
                >
                  <Avatar
                    :name="agent.name"
                    :src="agent.avatar_url"
                    :size="24"
                    :status="agent.availability_status"
                  />
                  <div class="flex items-center gap-2 flex-1 min-w-0 flex-wrap">
                    <span class="text-sm">{{ agent.name }}</span>
                    <span
                      class="px-2 py-0.5 text-xs bg-n-alpha-2 text-n-slate-11 rounded-full capitalize"
                      >{{ agent.role }}</span>
                    <span
                      v-if="agent.role === 'administrator'"
                      class="text-xs text-n-slate-11"
                    >
                      {{ t('KANBAN.FUNNELS.FORM.AGENTS.ADMIN_SEES_ALL_ITEMS') }}
                    </span>
                    <span
                      v-if="agent.role === 'agent'"
                      class="text-xs text-n-slate-11"
                    >
                      {{
                        t('KANBAN.FUNNELS.FORM.AGENTS.AGENT_SEES_ASSIGNED_ONLY')
                      }}
                    </span>
                  </div>
                  <label
                    class="flex items-center gap-2 shrink-0 text-xs text-n-slate-11"
                  >
                    <input
                      :checked="agent.is_supervisor"
                      type="checkbox"
                      class="h-4 w-4 rounded border-n-weak text-woot-500 focus:ring-woot-500"
                      @change="toggleSupervisor(agent.id)"
                    />
                    Supervisor
                  </label>
                  <button
                    type="button"
                    class="ml-auto shrink-0 text-xs text-ruby-500 hover:text-ruby-600"
                    @click="removeAgent(agent)"
                  >
                    ✕
                  </button>
                </div>
              </div>
              <!-- Estado vazio -->
              <div
                v-if="!formData.agents.length"
                class="text-center py-8 text-n-slate-10"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-users-icon lucide-users mb-2 opacity-50 mx-auto"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <circle cx="9" cy="7" r="4" />
                </svg>
                <p class="text-sm">Nenhum agente selecionado</p>
                <p class="text-xs">
                  Use o campo de busca acima para adicionar agentes ao funil
                </p>
              </div>
            </div>
          </div>

          <!-- Coluna Direita - Lista de Etapas -->
          <div class="space-y-6 min-w-0 w-full">
            <div>
              <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-2 text-sm font-medium">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-columns3-icon lucide-columns-3"
                  >
                    <rect width="18" height="18" x="3" y="3" rx="2" />
                    <path d="M9 3v18" />
                    <path d="M15 3v18" />
                  </svg>
                  <span>{{
                    t('KANBAN.FUNNELS.FORM.SECTIONS.FUNNEL_STAGES')
                  }}</span>
                </div>
                <div class="flex items-center gap-2">
                  <Button
                    type="button"
                    variant="solid"
                    color="blue"
                    size="sm"
                    :label="t('KANBAN.FUNNELS.FORM.STAGES.ADD_NEW_BUTTON')"
                    @click="openNewStageModal"
                  >
                    <template #icon>
                      <span class="i-ri-add-line size-4" />
                    </template>
                  </Button>
                  <span
                    class="px-2 py-1 text-xs bg-n-solid-2 text-n-slate-11 rounded-full"
                  >
                    {{ stages.length }}
                  </span>
                </div>
              </div>

              <!-- Lista de Etapas -->
              <div class="space-y-2">
                <draggable
                  v-model="stages"
                  :options="dragOptions"
                  item-key="id"
                  class="space-y-2"
                  @change="handleOrderChange"
                >
                  <template #item="{ element: stage, index }">
                    <div
                      class="stage-preview-card flex flex-col border border-n-weak rounded-xl cursor-move group transition-all duration-200 bg-n-solid-2"
                    >
                      <!-- Header do Card -->
                      <div
                        class="flex items-center justify-between p-3 border-b border-n-weak rounded-t-lg"
                      >
                        <div class="flex items-center gap-3 flex-1 min-w-0">
                          <div
                            class="w-3 h-3 rounded-full flex-shrink-0"
                            :style="{ backgroundColor: stage.color }"
                          />
                          <div class="flex-1 min-w-0">
                            <div
                              class="text-sm font-semibold text-n-slate-12 truncate"
                              :title="stage.name"
                            >
                              {{ stage.name }}
                            </div>
                            <div
                              v-if="stage.description"
                              class="text-xs text-n-slate-11 mt-0.5 line-clamp-2"
                            >
                              {{ stage.description }}
                            </div>
                          </div>
                        </div>
                        <div class="flex items-center gap-1 ml-2">
                          <div class="relative">
                            <button
                              type="button"
                              class="text-n-slate-10 hover:text-n-slate-11 p-1 rounded hover:bg-n-alpha-2 transition-colors"
                              :title="'Copiar ID: ' + stage.id"
                              @click.stop="copyStageId(stage.id)"
                            >
                              <span class="i-ri-file-copy-line size-3" />
                            </button>
                            <span
                              v-if="copiedStageId[stage.id]"
                              class="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 text-xs rounded bg-n-solid-3 text-white whitespace-nowrap z-10"
                              >Copiado!</span
                            >
                          </div>
                          <button
                            type="button"
                            class="text-n-slate-10 hover:text-n-slate-11 p-1 rounded hover:bg-n-alpha-2 transition-colors"
                            title="Editar etapa"
                            @click.stop="startEditing(stage)"
                          >
                            <span class="i-ri-pencil-line size-3" />
                          </button>
                          <button
                            type="button"
                            class="text-n-slate-10 hover:text-red-500 dark:hover:text-red-400 p-1 rounded hover:bg-n-alpha-2 transition-colors"
                            title="Remover etapa"
                            @click.stop="removeStage(index)"
                          >
                            <span class="i-ri-delete-bin-line size-3" />
                          </button>
                        </div>
                      </div>

                      <!-- Conteúdo do Card -->
                      <div class="p-3 space-y-3">
                        <!-- SLA da etapa -->
                        <div
                          v-if="hasStageSla(stage)"
                          class="bg-amber-50 dark:bg-amber-900/20 rounded-xl p-2"
                        >
                          <div
                            class="text-xs font-medium text-amber-800 dark:text-amber-200 mb-1 flex items-center gap-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="text-amber-600 dark:text-amber-400 shrink-0"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <polyline points="12 6 12 12 16 14" />
                            </svg>
                            {{ t('KANBAN.FUNNELS.FORM.STAGES.SLA_LABEL') }}
                          </div>
                          <div
                            class="text-xs text-amber-700 dark:text-amber-300"
                          >
                            {{ stage.sla }}
                            {{ t('KANBAN.FUNNELS.FORM.STAGES.SLA_UNIT') }}
                          </div>
                        </div>

                        <div
                          v-if="hasStageCapacityLimit(stage)"
                          class="bg-purple-50 dark:bg-purple-900/20 rounded-xl p-2"
                        >
                          <div
                            class="text-xs font-medium text-purple-800 dark:text-purple-200 mb-1 flex items-center gap-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="text-purple-600 dark:text-purple-400 shrink-0"
                            >
                              <rect x="9" y="2" width="6" height="4" rx="1" />
                              <path
                                d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2"
                              />
                              <path d="M9 12h6" />
                              <path d="M9 16h4" />
                            </svg>
                            Capacidade limite
                          </div>
                          <div
                            class="text-xs text-purple-700 dark:text-purple-300"
                          >
                            {{ stage.capacity_limit }} itens
                          </div>
                        </div>

                        <!-- Condições de Auto Criação -->
                        <div
                          v-if="
                            stage.auto_create_conditions &&
                            stage.auto_create_conditions.length > 0
                          "
                          class="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-2"
                        >
                          <div
                            class="text-xs font-medium text-blue-700 dark:text-blue-300 mb-2 flex items-center gap-1"
                          >
                            <span class="i-ri-settings-line size-2.5" />
                            Auto criação
                          </div>
                          <div class="flex flex-wrap gap-1">
                            <span
                              v-for="(
                                condition, index
                              ) in stage.auto_create_conditions"
                              :key="index"
                              class="inline-flex items-center gap-1 text-xs px-2 py-1 bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 rounded-full"
                            >
                              <span class="truncate">{{
                                getConditionTypeLabel(condition.type)
                              }}</span>
                              <span class="font-medium">{{
                                condition.value
                              }}</span>
                            </span>
                          </div>
                        </div>

                        <!-- Checklist Templates -->
                        <div
                          v-if="
                            stage.checklist_templates &&
                            stage.checklist_templates.length > 0
                          "
                          class="bg-n-alpha-2/50 rounded-xl p-2"
                        >
                          <div
                            class="text-xs font-medium text-n-slate-12 mb-2 flex items-center gap-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="text-green-600"
                            >
                              <path d="M16 5H3" />
                              <path d="M16 12H3" />
                              <path d="M11 19H3" />
                              <path d="m15 18 2 2 4-4" />
                            </svg>
                            Checklist
                          </div>
                          <div class="text-xs text-n-slate-11">
                            {{ stage.checklist_templates.length }} item{{
                              stage.checklist_templates.length !== 1 ? 's' : ''
                            }}
                            pré-configurado{{
                              stage.checklist_templates.length !== 1 ? 's' : ''
                            }}
                          </div>
                        </div>

                        <!-- Estado vazio -->
                        <div
                          v-if="
                            (!stage.auto_create_conditions ||
                              stage.auto_create_conditions.length === 0) &&
                            (!stage.checklist_templates ||
                              stage.checklist_templates.length === 0) &&
                            !hasStageSla(stage) &&
                            !hasStageCapacityLimit(stage)
                          "
                          class="text-center py-4 text-n-slate-10"
                        >
                          <span
                            class="i-ri-information-line size-4 mx-auto mb-1 opacity-50"
                          />
                          <p class="text-xs">
                            {{
                              t(
                                'KANBAN.FUNNELS.FORM.STAGES.PREVIEW_NO_EXTRA_INFO'
                              )
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>

                <!-- Empty State -->
                <div
                  v-if="!stages.length"
                  class="flex flex-col items-center justify-center py-8 text-n-slate-10"
                >
                  <span class="i-ri-list-view size-8 mb-2" />
                  <p class="text-sm">
                    {{ t('KANBAN.FUNNELS.FORM.STAGES.EMPTY') }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Status e Configurações -->
            <div class="mt-6 space-y-4">
              <!-- Histórico de Otimizações -->
              <div
                v-if="funnelMetadata.optimization_history?.length > 0"
                class="space-y-2"
              >
                <label class="text-sm font-medium text-n-slate-12">
                  Histórico de Otimizações
                </label>
                <div class="space-y-1">
                  <div
                    v-for="(
                      optimization, index
                    ) in funnelMetadata.optimization_history.slice(-3)"
                    :key="index"
                    class="text-xs text-n-slate-11 bg-n-solid-2 px-2 py-1 rounded"
                  >
                    {{ new Date(optimization.date).toLocaleDateString() }} -
                    {{ optimization.type }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab de Campos Personalizados Globais -->
      <div v-if="activeFormTab === 'global-fields'">
        <div class="border border-n-weak rounded-xl p-4 space-y-4">
          <div class="space-y-4">
            <div
              v-for="(attr, idx) in globalCustomAttributes || []"
              :key="idx"
              class="border border-n-weak rounded-xl p-3 space-y-2"
            >
              <div class="flex gap-2 items-center">
                <input
                  v-model="attr.name"
                  type="text"
                  class="w-1/2 rounded-xl"
                  placeholder="Chave (name)"
                />
                <select v-model="attr.type" class="w-1/2 rounded-xl">
                  <option value="" disabled selected>Tipo</option>
                  <option value="string">Texto</option>
                  <option value="number">Número</option>
                  <option value="date">Data</option>
                  <option value="boolean">Verdadeiro/Falso</option>
                </select>
                <select
                  v-model="attr.field_type"
                  class="px-2 py-1 border rounded text-sm w-36 h-10 align-middle"
                >
                  <option value="single">Único</option>
                  <option value="list">Lista</option>
                </select>
                <button
                  type="button"
                  class="p-1 text-ruby-500"
                  @click="removeGlobalCustomAttribute(idx)"
                >
                  ✕
                </button>
              </div>

              <!-- Input para valores da lista -->
              <div v-if="attr.field_type === 'list'" class="pl-2 space-y-2">
                <label class="text-xs font-medium text-n-slate-11">Valores da lista:</label>
                <div
                  v-for="(value, valueIdx) in attr.list_values || []"
                  :key="valueIdx"
                  class="flex gap-2 items-center"
                >
                  <input
                    v-model="attr.list_values[valueIdx]"
                    type="text"
                    class="flex-1 px-2 py-1 border rounded text-sm"
                    placeholder="Valor"
                  />
                  <button
                    type="button"
                    class="text-ruby-500 text-sm"
                    @click="removeListValue(idx, valueIdx)"
                  >
                    ✕
                  </button>
                </div>
                <button
                  type="button"
                  class="text-xs px-2 py-1 bg-n-alpha-2 text-n-slate-11 rounded hover:bg-n-alpha-2"
                  @click="addListValue(idx)"
                >
                  + Adicionar valor
                </button>
              </div>
            </div>
            <button
              type="button"
              class="mt-2 px-3 py-1 bg-woot-500 text-white rounded"
              @click="addGlobalCustomAttribute"
            >
              Adicionar campo
            </button>
          </div>
        </div>
      </div>

      <!-- Tab de Configurações -->
      <div v-if="activeFormTab === 'settings'">
        <div class="border border-n-weak rounded-xl p-4 space-y-6">
          <!-- Automações por status (SiteUp V2, 2026-08-11): vieram da aba
               "Automação" do CARD. A regra sempre valeu para todos os cards
               deste funil — dentro do card, qualquer um configurava achando
               que mexia só naquele lead. -->
          <div data-testid="funnel-status-automations">
            <div class="flex items-center justify-between">
              <label class="block text-sm font-medium">
                {{ t('KANBAN.FUNNELS.FORM.SETTINGS.STATUS_AUTOMATIONS_LABEL') }}
              </label>
              <button
                type="button"
                data-testid="funnel-add-status-automation"
                class="text-xs font-bold text-n-blue-11 hover:underline"
                @click="addStatusAutomation"
              >
                ＋ {{ t('KANBAN.FUNNELS.FORM.SETTINGS.ADD_AUTOMATION') }}
              </button>
            </div>
            <p class="text-xs text-n-slate-11 mt-1">
              {{ t('KANBAN.FUNNELS.FORM.SETTINGS.STATUS_AUTOMATIONS_HELP') }}
            </p>

            <p
              v-if="!statusAutomations.length"
              class="mt-3 text-xs italic text-n-slate-11"
            >
              {{ t('KANBAN.FUNNELS.FORM.SETTINGS.NO_AUTOMATIONS') }}
            </p>

            <div
              v-for="(automation, index) in statusAutomations"
              :key="automation.id"
              class="mt-3 rounded-xl border border-n-weak bg-n-solid-2 p-3 space-y-3"
            >
              <div class="flex items-center justify-between gap-3">
                <div class="flex items-center gap-2">
                  <Switch v-model="automation.enabled" size="small" />
                  <span class="text-xs text-n-slate-11">
                    {{
                      automation.enabled
                        ? t('KANBAN.FUNNELS.FORM.SETTINGS.AUTOMATION_ON')
                        : t('KANBAN.FUNNELS.FORM.SETTINGS.AUTOMATION_OFF')
                    }}
                  </span>
                </div>
                <button
                  type="button"
                  :data-testid="`funnel-remove-automation-${index}`"
                  class="text-xs font-medium text-n-ruby-11 hover:underline"
                  @click="removeStatusAutomation(index)"
                >
                  {{ t('KANBAN.FUNNELS.FORM.SETTINGS.REMOVE_AUTOMATION') }}
                </button>
              </div>

              <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <label class="block text-xs text-n-slate-11">
                  {{ t('KANBAN.FUNNELS.FORM.SETTINGS.WHEN_STATUS_BECOMES') }}
                  <select
                    v-model="automation.trigger_value"
                    class="mt-1 w-full rounded-xl border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
                  >
                    <option value="" disabled>
                      {{ t('KANBAN.FORM.CUSTOM_FIELDS.SELECT') }}
                    </option>
                    <option
                      v-for="trigger in statusTriggers"
                      :key="trigger.id"
                      :value="trigger.id"
                    >
                      {{ trigger.name }}
                    </option>
                  </select>
                </label>

                <label class="block text-xs text-n-slate-11">
                  {{ t('KANBAN.FUNNELS.FORM.SETTINGS.THEN_DO') }}
                  <select
                    v-model="automation.action"
                    class="mt-1 w-full rounded-xl border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
                    @change="automation.action_config = {}"
                  >
                    <option value="" disabled>
                      {{ t('KANBAN.FORM.CUSTOM_FIELDS.SELECT') }}
                    </option>
                    <option
                      v-for="action in statusActions"
                      :key="action.id"
                      :value="action.id"
                    >
                      {{ action.name }}
                    </option>
                  </select>
                </label>
              </div>

              <!-- Configuração da ação escolhida -->
              <label
                v-if="automation.action === 'move_to_stage'"
                class="block text-xs text-n-slate-11"
              >
                {{ t('KANBAN.FORM.STAGE.LABEL') }}
                <select
                  v-model="automation.action_config.stage"
                  class="mt-1 w-full rounded-xl border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
                >
                  <option value="" disabled>
                    {{ t('KANBAN.FORM.STAGE.PLACEHOLDER') }}
                  </option>
                  <option v-for="stage in stages" :key="stage.id" :value="stage.id">
                    {{ stage.name }}
                  </option>
                </select>
              </label>

              <label
                v-else-if="automation.action === 'assign_agent'"
                class="block text-xs text-n-slate-11"
              >
                {{ t('KANBAN.FORM.AGENT.LABEL') }}
                <select
                  v-model="automation.action_config.agent_id"
                  class="mt-1 w-full rounded-xl border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
                >
                  <option value="" disabled>
                    {{ t('KANBAN.FORM.AGENT.PLACEHOLDER') }}
                  </option>
                  <option v-for="agent in agentsList" :key="agent.id" :value="agent.id">
                    {{ agent.name }}
                  </option>
                </select>
              </label>

              <label
                v-else-if="automation.action === 'create_note'"
                class="block text-xs text-n-slate-11"
              >
                {{ t('KANBAN.TABS.NOTES') }}
                <textarea
                  v-model="automation.action_config.note_text"
                  rows="2"
                  class="mt-1 w-full rounded-xl border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
                  :placeholder="t('KANBAN.FORM.NOTES.PLACEHOLDER')"
                />
              </label>

              <label
                v-else-if="automation.action === 'notify_team'"
                class="block text-xs text-n-slate-11"
              >
                {{ t('KANBAN.FUNNELS.FORM.SETTINGS.NOTIFY_MESSAGE') }}
                <input
                  v-model="automation.action_config.message"
                  type="text"
                  class="mt-1 w-full rounded-xl border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
                />
              </label>
            </div>
          </div>

          <!-- Round Robin -->
          <div>
            <div class="flex items-center justify-between">
              <label class="block text-sm font-medium">
                {{ t('KANBAN.FUNNELS.FORM.SETTINGS.ROUND_ROBIN_LABEL') }}
              </label>
              <Switch
                v-model="formData.settings.round_robin_distribution"
                size="small"
              />
            </div>
            <p class="text-xs text-n-slate-11 mt-1">
              {{ t('KANBAN.FUNNELS.FORM.SETTINGS.ROUND_ROBIN_HELP') }}
            </p>
          </div>

          <!-- Require Loss Reason -->
          <div>
            <div class="flex items-center justify-between">
              <label class="block text-sm font-medium">
                {{
                  t('KANBAN.FUNNELS.FORM.SETTINGS.REQUIRE_LOSS_REASON_LABEL')
                }}
              </label>
              <Switch
                v-model="formData.settings.require_loss_reason"
                size="small"
              />
            </div>
            <p class="text-xs text-n-slate-11 mt-1">
              {{ t('KANBAN.FUNNELS.FORM.SETTINGS.REQUIRE_LOSS_REASON_HELP') }}
            </p>
          </div>

          <!-- Default Currency -->
          <div>
            <label class="block text-sm font-medium mb-2">
              {{ t('KANBAN.FUNNELS.FORM.SETTINGS.DEFAULT_CURRENCY_LABEL') }}
            </label>
            <select
              v-model="formData.settings.default_currency"
              class="w-full rounded-xl border border-n-weak px-3 py-2 text-n-slate-12 focus:border-woot-500 focus:outline-none focus:ring-1 focus:ring-woot-500 bg-n-solid-2"
            >
              <option value="BRL">BRL - Real Brasileiro</option>
              <option value="USD">USD - US Dollar</option>
              <option value="EUR">EUR - Euro</option>
            </select>
            <p class="text-xs text-n-slate-11 mt-1">
              {{ t('KANBAN.FUNNELS.FORM.SETTINGS.DEFAULT_CURRENCY_HELP') }}
            </p>
          </div>

          <!-- Appointment WAHA -->
          <div class="border-t border-n-weak pt-6">
            <div class="flex items-start justify-between gap-4">
              <div>
                <label class="block text-sm font-medium text-n-slate-12">
                  Agendamento
                </label>
                <p class="text-xs text-n-slate-11 mt-1">
                  Enviar confirmação de agendamento para o lead, sempre com
                  preview e confirmação manual.
                </p>
              </div>
              <Switch
                v-model="appointmentConfig.enabled"
                size="small"
                :disabled="loadingAppointmentConfig"
              />
            </div>

            <div
              class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4 rounded-xl border border-n-weak bg-n-alpha-1 p-4"
            >
              <div>
                <label class="block text-xs font-medium text-n-slate-11 mb-1">
                  Título padrão
                </label>
                <input
                  v-model="appointmentConfig.default_title"
                  type="text"
                  class="w-full rounded-xl border border-n-weak px-3 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 focus:border-woot-500 focus:outline-none focus:ring-1 focus:ring-woot-500 bg-n-solid-1"
                />
              </div>
              <div>
                <label class="block text-xs font-medium text-n-slate-11 mb-1">
                  Endereço/local padrão
                </label>
                <input
                  v-model="appointmentConfig.default_location"
                  type="text"
                  class="w-full rounded-xl border border-n-weak px-3 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 focus:border-woot-500 focus:outline-none focus:ring-1 focus:ring-woot-500 bg-n-solid-1"
                  placeholder="Ex: Av. Brasil, 123"
                />
              </div>
              <div>
                <label class="block text-xs font-medium text-n-slate-11 mb-1">
                  Duração padrão (min)
                </label>
                <input
                  v-model.number="appointmentConfig.default_duration_minutes"
                  type="number"
                  min="5"
                  class="w-full rounded-xl border border-n-weak px-3 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 focus:border-woot-500 focus:outline-none focus:ring-1 focus:ring-woot-500 bg-n-solid-1"
                />
              </div>
              <div>
                <label class="block text-xs font-medium text-n-slate-11 mb-1">
                  Responsável padrão
                </label>
                <input
                  v-model="appointmentConfig.responsible_name"
                  type="text"
                  class="w-full rounded-xl border border-n-weak px-3 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 focus:border-woot-500 focus:outline-none focus:ring-1 focus:ring-woot-500 bg-n-solid-1"
                  placeholder="Ex: Equipe comercial"
                />
              </div>
              <div class="md:col-span-2">
                <label class="block text-xs font-medium text-n-slate-11 mb-1">
                  Mensagem padrão
                </label>
                <textarea
                  v-model="appointmentConfig.message_template"
                  rows="4"
                  class="w-full rounded-xl border border-n-weak px-3 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 focus:border-woot-500 focus:outline-none focus:ring-1 focus:ring-woot-500 bg-n-solid-1"
                />
              </div>
            </div>

            <p class="text-xs text-n-slate-11 mt-2">
              Variáveis: {{ appointmentTemplateVariables }}
            </p>

            <div
              class="mt-4 rounded-xl border border-n-weak bg-n-alpha-1 p-4 space-y-3"
            >
              <div class="flex items-start justify-between gap-4">
                <div>
                  <label class="block text-xs font-medium text-n-slate-12">
                    Evento WAHA automático
                  </label>
                  <p class="text-xs text-n-slate-11 mt-1">
                    Criar uma mensagem agendada com evento WAHA quando um
                    agendamento do lead for criado.
                  </p>
                </div>
                <Switch
                  v-model="
                    appointmentAutomationConfig.send_waha_event_on_appointment
                  "
                  size="small"
                  :disabled="loadingAppointmentConfig"
                />
              </div>

              <div class="max-w-xs">
                <label class="block text-xs font-medium text-n-slate-11 mb-1">
                  Janela de confirmação (min)
                </label>
                <input
                  v-model.number="
                    appointmentAutomationConfig.waha_event_confirmation_window_min
                  "
                  type="number"
                  min="1"
                  class="w-full rounded-xl border border-n-weak px-3 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 focus:border-woot-500 focus:outline-none focus:ring-1 focus:ring-woot-500 disabled:cursor-not-allowed disabled:opacity-60 bg-n-solid-1"
                  :disabled="
                    !appointmentAutomationConfig.send_waha_event_on_appointment ||
                    loadingAppointmentConfig
                  "
                />
              </div>
            </div>

            <div class="flex flex-wrap items-center justify-end gap-3 mt-3">
              <span
                v-if="appointmentConfigStatus"
                class="text-xs text-green-600 dark:text-green-400"
              >
                {{ appointmentConfigStatus }}
              </span>
              <span v-if="appointmentConfigError" class="text-xs text-ruby-500">
                {{ appointmentConfigError }}
              </span>
              <Button
                type="button"
                variant="solid"
                color="blue"
                size="sm"
                :label="
                  savingAppointmentConfig ? 'Salvando...' : 'Salvar agendamento'
                "
                :disabled="savingAppointmentConfig || loadingAppointmentConfig"
                @click="saveAppointmentConfig"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Tab de Metas -->
      <div v-if="activeFormTab === 'goals'">
        <div class="flex justify-end mb-4">
          <Button
            type="button"
            variant="solid"
            color="blue"
            size="sm"
            :label="t('KANBAN.FUNNELS.FORM.GOALS.ADD_NEW_BUTTON')"
            @click="openNewGoalModal"
          >
            <template #icon>
              <span class="i-ri-add-line size-4" />
            </template>
          </Button>
        </div>

        <Dialog
          ref="goalDialogRef"
          width="lg"
          type="edit"
          :title="goalModalTitle"
          :show-cancel-button="false"
          :show-confirm-button="false"
          @close="handleGoalDialogClose"
        >
          <div class="space-y-4">
            <div v-if="editingGoal" class="flex justify-end">
              <span
                class="text-sm px-2 py-1 rounded"
                style="background-color: #3b82f620; color: #3b82f6"
              >
                {{ t('KANBAN.FUNNELS.FORM.GOALS.EDITING_BADGE') }}
              </span>
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.GOALS.TYPE_LABEL')
              }}</label>
              <div class="flex flex-wrap gap-2">
                <button
                  v-for="(type, key) in {
                    conversion_rate: {
                      label: t(
                        'KANBAN.FUNNELS.FORM.GOALS.TYPES.CONVERSION_RATE'
                      ),
                      color: '#3B82F6',
                    },
                    average_value: {
                      label: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.AVERAGE_VALUE'),
                      color: '#10B981',
                    },
                    average_time: {
                      label: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.AVERAGE_TIME'),
                      color: '#F59E0B',
                    },
                    total_conversions: {
                      label: t(
                        'KANBAN.FUNNELS.FORM.GOALS.TYPES.TOTAL_CONVERSIONS'
                      ),
                      color: '#8B5CF6',
                    },
                    total_revenue: {
                      label: t('KANBAN.FUNNELS.FORM.GOALS.TYPES.TOTAL_REVENUE'),
                      color: '#EF4444',
                    },
                  }"
                  :key="key"
                  type="button"
                  class="flex items-center gap-2 px-3 py-2 rounded-xl border transition-colors"
                  :style="
                    newGoal.type === key
                      ? {
                          borderColor: type.color,
                          backgroundColor: type.color + '80',
                          color: type.color,
                        }
                      : {
                          borderColor: type.color,
                          backgroundColor: 'transparent',
                          color: type.color,
                        }
                  "
                  @click="newGoal.type = key"
                >
                  <span class="text-sm">{{ type.label }}</span>
                </button>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.GOALS.VALUE_LABEL')
              }}</label>
              <div class="flex items-center gap-2">
                <input
                  v-model="newGoal.value"
                  :type="
                    ['percentage', 'currency', 'count'].includes(newGoal.unit)
                      ? 'number'
                      : 'text'
                  "
                  class="w-full px-3 py-2 border rounded-xl"
                  :placeholder="
                    newGoal.type === 'conversion_rate'
                      ? t(
                          'KANBAN.FUNNELS.FORM.GOALS.VALUE_PLACEHOLDER.CONVERSION_RATE'
                        )
                      : newGoal.type === 'average_value'
                        ? t(
                            'KANBAN.FUNNELS.FORM.GOALS.VALUE_PLACEHOLDER.AVERAGE_VALUE'
                          )
                        : newGoal.type === 'average_time'
                          ? t(
                              'KANBAN.FUNNELS.FORM.GOALS.VALUE_PLACEHOLDER.AVERAGE_TIME'
                            )
                          : t(
                              'KANBAN.FUNNELS.FORM.GOALS.VALUE_PLACEHOLDER.DEFAULT'
                            )
                  "
                />
                <span class="text-sm text-n-slate-11 px-2">{{
                  getUnitLabel(newGoal.unit)
                }}</span>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.GOALS.DESCRIPTION_LABEL')
              }}</label>
              <input
                v-model="newGoal.description"
                type="text"
                class="w-full px-3 py-2 border rounded-xl"
                :placeholder="
                  t('KANBAN.FUNNELS.FORM.GOALS.DESCRIPTION_PLACEHOLDER')
                "
              />
            </div>
          </div>
          <template #footer>
            <div class="flex w-full flex-wrap justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                color="slate"
                size="sm"
                :label="t('KANBAN.FUNNELS.FORM.ACTIONS.CANCEL')"
                @click="cancelEditingGoal"
              />
              <Button
                type="button"
                variant="solid"
                color="blue"
                size="sm"
                :disabled="!newGoal.value"
                :label="
                  editingGoal
                    ? t('KANBAN.FUNNELS.FORM.ACTIONS.SAVE')
                    : t('KANBAN.FUNNELS.FORM.GOALS.ADD_BUTTON')
                "
                @click="addGoal"
              />
            </div>
          </template>
        </Dialog>

        <!-- Lista de Metas Configuradas -->
        <div v-if="goals.length > 0" class="mt-4 space-y-2">
          <h4 class="text-sm font-medium text-n-slate-12 mb-3">
            {{ t('KANBAN.FUNNELS.FORM.GOALS.CONFIGURED_TITLE') }}
          </h4>
          <div
            v-for="(goal, index) in goals"
            :key="goal.id"
            class="flex items-center justify-between p-3 bg-n-solid-2 rounded-xl border border-n-weak"
          >
            <div class="flex items-center gap-3">
              <div class="flex items-center gap-2">
                <span class="text-sm font-medium">{{
                  getGoalTypeLabel(goal.type)
                }}</span>
              </div>
              <div class="flex items-center gap-1">
                <span
                  class="text-sm font-medium text-blue-600 dark:text-blue-400"
                  >{{ goal.value }}</span>
                <span class="text-xs text-n-slate-11">{{
                  getUnitLabel(goal.unit)
                }}</span>
              </div>
              <div
                v-if="goal.description"
                class="text-xs text-n-slate-11 italic"
              >
                {{ goal.description }}
              </div>
            </div>
            <div class="flex items-center gap-1">
              <button
                type="button"
                class="text-n-slate-10 hover:text-n-slate-11 p-1"
                @click="startEditingGoal(goal)"
              >
                <span class="i-ri-pencil-line size-3.5" />
              </button>
              <button
                type="button"
                class="text-n-slate-10 hover:text-n-slate-11 p-1"
                @click="removeGoal(index)"
              >
                <span class="i-ri-delete-bin-line size-3.5" />
              </button>
            </div>
          </div>
        </div>

        <!-- Estado vazio -->
        <div v-else class="mt-4 text-center py-8 text-n-slate-10">
          <p class="text-sm">
            {{ t('KANBAN.FUNNELS.FORM.GOALS.EMPTY_STATE') }}
          </p>
          <p class="text-xs">
            {{ t('KANBAN.FUNNELS.FORM.GOALS.EMPTY_DESCRIPTION') }}
          </p>
        </div>
      </div>

      <!-- Tab de Motivos de Perda e Ganho -->
      <div v-if="activeFormTab === 'loss-win-reasons'">
        <div class="flex justify-end mb-4">
          <Button
            type="button"
            variant="solid"
            color="blue"
            size="sm"
            :label="t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.ADD_NEW_BUTTON')"
            @click="openNewReasonModal"
          >
            <template #icon>
              <span class="i-ri-add-line size-4" />
            </template>
          </Button>
        </div>

        <Dialog
          ref="reasonDialogRef"
          width="lg"
          type="edit"
          :title="reasonModalTitle"
          :show-cancel-button="false"
          :show-confirm-button="false"
          @close="handleReasonDialogClose"
        >
          <div class="space-y-4">
            <div v-if="editingReason" class="flex justify-end">
              <span
                class="text-sm px-2 py-1 rounded"
                :style="{
                  backgroundColor:
                    newReason.type === 'loss' ? '#E11D4820' : '#14B8A620',
                  color: newReason.type === 'loss' ? '#E11D48' : '#14B8A6',
                }"
              >
                {{ t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.EDITING_BADGE') }}
              </span>
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.TYPE_LABEL')
              }}</label>
              <div class="flex gap-2">
                <button
                  type="button"
                  class="flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-xl border-2 transition-colors"
                  :style="
                    newReason.type === 'loss'
                      ? {
                          borderColor: '#E11D48',
                          backgroundColor: '#FFF1F2',
                          color: '#E11D48',
                        }
                      : {
                          borderColor: '#E2E8F0',
                          backgroundColor: 'transparent',
                          color: '#64748B',
                        }
                  "
                  @click="newReason.type = 'loss'"
                >
                  <span class="text-sm font-medium">{{
                    t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.TYPE_LOSS')
                  }}</span>
                </button>
                <button
                  type="button"
                  class="flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-xl border-2 transition-colors"
                  :style="
                    newReason.type === 'win'
                      ? {
                          borderColor: '#14B8A6',
                          backgroundColor: '#F0FDFA',
                          color: '#14B8A6',
                        }
                      : {
                          borderColor: '#E2E8F0',
                          backgroundColor: 'transparent',
                          color: '#64748B',
                        }
                  "
                  @click="newReason.type = 'win'"
                >
                  <span class="text-sm font-medium">{{
                    t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.TYPE_WIN')
                  }}</span>
                </button>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.TITLE_LABEL')
              }}</label>
              <input
                v-model="newReason.title"
                type="text"
                class="w-full px-3 py-2 border rounded-xl"
                :placeholder="
                  t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.TITLE_PLACEHOLDER')
                "
              />
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.DESCRIPTION_LABEL')
              }}</label>
              <textarea
                v-model="newReason.description"
                rows="2"
                class="w-full px-3 py-2 border rounded-xl"
                :placeholder="
                  t(
                    'KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.DESCRIPTION_PLACEHOLDER'
                  )
                "
              />
            </div>
          </div>
          <template #footer>
            <div class="flex w-full flex-wrap justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                color="slate"
                size="sm"
                :label="t('KANBAN.FUNNELS.FORM.ACTIONS.CANCEL')"
                @click="cancelEditingReason"
              />
              <Button
                type="button"
                variant="solid"
                :color="newReason.type === 'loss' ? 'ruby' : 'teal'"
                size="sm"
                :disabled="!newReason.title.trim()"
                :label="
                  editingReason
                    ? t('KANBAN.FUNNELS.FORM.ACTIONS.SAVE')
                    : t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.ADD_BUTTON')
                "
                @click="addReason"
              />
            </div>
          </template>
        </Dialog>

        <!-- Listas de Motivos -->
        <div class="mt-4 grid grid-cols-2 gap-4">
          <!-- Motivos de Perda -->
          <div>
            <h4
              class="text-sm font-medium text-ruby-700 dark:text-ruby-300 mb-3 flex items-center gap-2"
            >
              <span>{{
                t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.LOSS_REASONS_TITLE')
              }}</span>
              <span
                class="px-2 py-0.5 text-xs bg-ruby-100 dark:bg-ruby-900/20 rounded-full"
                >{{ lossReasons.length }}</span>
            </h4>
            <div v-if="lossReasons.length > 0" class="space-y-2">
              <div
                v-for="(reason, index) in lossReasons"
                :key="reason.id"
                class="p-3 rounded-xl border"
                style="background-color: #fff1f2; border-color: #ffe4e6"
              >
                <div class="flex items-start justify-between mb-1">
                  <span class="text-sm font-medium text-n-slate-12">{{
                    reason.title
                  }}</span>
                  <div class="flex items-center gap-1">
                    <button
                      type="button"
                      class="text-n-slate-10 hover:text-n-slate-11 p-1"
                      @click="startEditingReason('loss', reason)"
                    >
                      <span class="i-ri-pencil-line size-3.5" />
                    </button>
                    <button
                      type="button"
                      class="text-n-slate-10 hover:text-n-slate-11 p-1"
                      @click="removeReason('loss', index)"
                    >
                      <span class="i-ri-delete-bin-line size-3.5" />
                    </button>
                  </div>
                </div>
                <p v-if="reason.description" class="text-xs text-n-slate-11">
                  {{ reason.description }}
                </p>
              </div>
            </div>
            <div v-else class="text-center py-4 text-n-slate-10">
              <p class="text-xs">
                {{ t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.EMPTY_LOSS') }}
              </p>
            </div>
          </div>

          <!-- Motivos de Ganho -->
          <div>
            <h4
              class="text-sm font-medium text-teal-700 dark:text-teal-300 mb-3 flex items-center gap-2"
            >
              <span>{{
                t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.WIN_REASONS_TITLE')
              }}</span>
              <span
                class="px-2 py-0.5 text-xs bg-teal-100 dark:bg-teal-900/20 rounded-full"
                >{{ winReasons.length }}</span>
            </h4>
            <div v-if="winReasons.length > 0" class="space-y-2">
              <div
                v-for="(reason, index) in winReasons"
                :key="reason.id"
                class="p-3 rounded-xl border"
                style="background-color: #f0fdfa; border-color: #ccfbf1"
              >
                <div class="flex items-start justify-between mb-1">
                  <span class="text-sm font-medium text-n-slate-12">{{
                    reason.title
                  }}</span>
                  <div class="flex items-center gap-1">
                    <button
                      type="button"
                      class="text-n-slate-10 hover:text-n-slate-11 p-1"
                      @click="startEditingReason('win', reason)"
                    >
                      <span class="i-ri-pencil-line size-3.5" />
                    </button>
                    <button
                      type="button"
                      class="text-n-slate-10 hover:text-n-slate-11 p-1"
                      @click="removeReason('win', index)"
                    >
                      <span class="i-ri-delete-bin-line size-3.5" />
                    </button>
                  </div>
                </div>
                <p v-if="reason.description" class="text-xs text-n-slate-11">
                  {{ reason.description }}
                </p>
              </div>
            </div>
            <div v-else class="text-center py-4 text-n-slate-10">
              <p class="text-xs">
                {{ t('KANBAN.FUNNELS.FORM.LOSS_WIN_REASONS.EMPTY_WIN') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab de Checklist Presets -->
      <div v-if="activeFormTab === 'checklist-presets'">
        <Dialog
          ref="checklistDialogRef"
          width="lg"
          type="edit"
          :title="checklistModalTitle"
          :show-cancel-button="false"
          :show-confirm-button="false"
          @close="handleChecklistDialogClose"
        >
          <div class="space-y-4">
            <div
              v-if="selectedStageNameForChecklistModal"
              class="text-sm text-n-slate-11"
            >
              <span class="font-medium text-n-slate-12">{{
                  t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.STAGE_LABEL')
                }}:</span>
              {{ selectedStageNameForChecklistModal }}
            </div>
            <div v-if="editingChecklistItem" class="flex justify-end">
              <span
                class="text-sm px-2 py-1 rounded"
                style="background-color: #3b82f620; color: #3b82f6"
              >
                {{ t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.EDITING_BADGE') }}
              </span>
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.TEXT_LABEL')
              }}</label>
              <textarea
                v-model="newChecklistItem.text"
                rows="3"
                class="w-full px-3 py-2 border rounded-xl"
                :placeholder="
                  t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.TEXT_PLACEHOLDER')
                "
              />
            </div>

            <div>
              <label class="block text-sm font-medium mb-2">{{
                t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.PRIORITY_LABEL')
              }}</label>
              <select
                v-model="newChecklistItem.priority"
                class="w-full px-3 py-2 border rounded-xl text-sm"
              >
                <option value="none">Nenhuma</option>
                <option value="low">Baixa</option>
                <option value="medium">Média</option>
                <option value="high">Alta</option>
                <option value="urgent">Urgente</option>
              </select>
            </div>

            <div>
              <div class="flex items-center justify-between">
                <label class="block text-sm font-medium"> Obrigatório </label>
                <Switch v-model="newChecklistItem.required" size="small" />
              </div>
              <p class="text-xs text-n-slate-11 mt-1">
                Marque se este item deve ser obrigatoriamente concluído
              </p>
            </div>
          </div>
          <template #footer>
            <div class="flex w-full flex-wrap justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                color="slate"
                size="sm"
                :label="t('KANBAN.FUNNELS.FORM.ACTIONS.CANCEL')"
                @click="cancelEditingChecklistPreset"
              />
              <Button
                type="button"
                variant="solid"
                color="blue"
                size="sm"
                :disabled="!newChecklistItem.text.trim()"
                :label="
                  editingChecklistItem
                    ? t('KANBAN.FUNNELS.FORM.ACTIONS.SAVE')
                    : t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.ADD_BUTTON')
                "
                @click="addChecklistPreset"
              />
            </div>
          </template>
        </Dialog>

        <!-- Checklist presets agrupados por etapa -->
        <div v-if="!stages.length" class="text-center py-10 text-n-slate-11">
          <span class="i-ri-list-view size-12 mx-auto mb-4 opacity-50" />
          <p class="text-sm">
            {{ t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.NO_STAGES_HINT') }}
          </p>
        </div>

        <div v-else class="space-y-10 mt-2">
          <div v-for="stage in stages" :key="stage.id" class="space-y-3">
            <div class="flex flex-wrap items-center justify-between gap-3">
              <div class="flex min-w-0 flex-1 items-center gap-2">
                <div
                  class="h-2.5 w-2.5 shrink-0 rounded-full"
                  :style="{ backgroundColor: stage.color }"
                />
                <h4
                  class="flex min-w-0 items-center gap-2 text-lg font-extrabold text-n-slate-12"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="shrink-0 text-n-slate-11"
                  >
                    <path d="M16 5H3" />
                    <path d="M16 12H3" />
                    <path d="M11 19H3" />
                    <path d="m15 18 2 2 4-4" />
                  </svg>
                  <span class="truncate">{{ stage.name }}</span>
                  <span
                    class="shrink-0 rounded-full px-2 py-0.5 text-xs font-medium text-n-slate-11 bg-n-solid-2"
                  >
                    {{ (stage.checklist_templates || []).length }}
                  </span>
                  <span class="shrink-0 text-xs font-normal text-n-slate-11">
                    {{
                      t(
                        'KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.AUTO_CREATE_HINT'
                      )
                    }}
                  </span>
                </h4>
              </div>
              <Button
                type="button"
                variant="solid"
                color="blue"
                size="sm"
                :label="
                  t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.ADD_NEW_BUTTON')
                "
                @click="openNewChecklistModal(stage.id)"
              >
                <template #icon>
                  <span class="i-ri-add-line size-4" />
                </template>
              </Button>
            </div>

            <div
              v-if="(stage.checklist_templates || []).length > 0"
              class="preset-checklist-section space-y-2"
            >
              <div
                v-for="(item, index) in stage.checklist_templates"
                :key="item.id"
                class="preset-checklist-item group"
              >
                <div class="flex items-start gap-3">
                  <div
                    class="mt-0.5 flex-shrink-0 text-n-slate-11"
                    aria-hidden="true"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-list-todo"
                    >
                      <path d="M13 5h8" />
                      <path d="M13 12h8" />
                      <path d="M13 19h8" />
                      <path d="m3 17 2 2 4-4" />
                      <rect x="3" y="4" width="6" height="6" rx="1" />
                    </svg>
                  </div>
                  <div class="min-w-0 flex-1">
                    <div class="flex items-start justify-between gap-2">
                      <div class="preset-checklist-text whitespace-pre-wrap">
                        {{ item.text }}
                      </div>
                      <div
                        class="flex shrink-0 items-center gap-1 opacity-0 transition-opacity group-hover:opacity-100"
                      >
                        <button
                          type="button"
                          class="p-1 text-n-slate-10 hover:text-n-slate-11"
                          @click="startEditingChecklistPreset(stage.id, item)"
                        >
                          <span class="i-ri-pencil-line size-3.5" />
                        </button>
                        <button
                          type="button"
                          class="p-1 text-n-slate-10 hover:text-n-ruby-9 dark:hover:text-n-ruby-4"
                          @click="removeChecklistPreset(stage.id, index)"
                        >
                          <span class="i-ri-delete-bin-line size-3.5" />
                        </button>
                      </div>
                    </div>
                    <div
                      v-if="
                        getChecklistPresetPriority(item.priority).label !==
                          'Nenhuma' || item.required
                      "
                      class="preset-checklist-metadata mt-2 flex flex-wrap items-center gap-2"
                    >
                      <div
                        v-if="
                          getChecklistPresetPriority(item.priority).label !==
                          'Nenhuma'
                        "
                        class="preset-checklist-priority"
                      >
                        <span
                          class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium"
                          :class="{
                            'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300':
                              getChecklistPresetPriority(item.priority)
                                .color === 'red',
                            'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300':
                              getChecklistPresetPriority(item.priority)
                                .color === 'orange',
                            'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300':
                              getChecklistPresetPriority(item.priority)
                                .color === 'yellow',
                            'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300':
                              getChecklistPresetPriority(item.priority)
                                .color === 'green',
                          }"
                        >
                          <svg
                            v-if="
                              getChecklistPresetPriority(item.priority).iconSvg
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="flex-shrink-0"
                            v-html="
                              getChecklistPresetPriority(item.priority).iconSvg
                            "
                          />
                          {{ getChecklistPresetPriority(item.priority).label }}
                        </span>
                      </div>
                      <span
                        v-if="item.required"
                        class="inline-flex items-center gap-1 rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
                      >
                        {{
                          t(
                            'KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.REQUIRED_BADGE'
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="rounded-xl border border-dashed border-n-weak py-8 text-center text-n-slate-11"
            >
              <span class="i-ri-list-view size-10 mx-auto mb-3 opacity-50" />
              <p class="text-sm">
                {{ t('KANBAN.FUNNELS.FORM.CHECKLIST_PRESETS.EMPTY_STATE') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Meta CAPI -->
      <div v-if="activeFormTab === 'meta-capi'">
        <div class="space-y-6">
          <div
            class="flex items-center justify-between p-4 rounded-2xl bg-n-solid-2/50"
          >
            <div>
              <label class="block text-sm font-medium">Conversions API (CAPI)</label>
              <p class="text-xs text-n-slate-11 mt-0.5">
                Enviar eventos de conversao para o Meta Ads quando leads avancam
                no funil
              </p>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input
                v-model="formData.settings.meta_capi.enabled"
                type="checkbox"
                class="sr-only peer"
              />
              <div
                class="w-9 h-5 bg-n-alpha-3 peer-checked:bg-blue-500 rounded-full transition-colors after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full"
              />
            </label>
          </div>

          <template v-if="formData.settings.meta_capi.enabled">
            <!-- Aviso pra usar o Gerador de Link -->
            <div
              class="rounded-xl border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-950/30 p-3 mb-4 flex items-start gap-3"
            >
              <span class="text-xl">&#128279;</span>
              <div class="flex-1 text-xs">
                <b class="block text-sm mb-0.5">Pra capturar fbclid/ctwa_clid em novos leads</b>
                <span class="text-n-slate-11">Crie um capturador no Gerador de Link e use a URL como Final
                  URL do anuncio Meta Ads ou em forms.</span>
                <router-link
                  :to="{ name: 'settings_integrations_lead_capture' }"
                  class="block mt-1 text-blue-600 dark:text-blue-400 font-medium"
                >
                  Abrir Gerador de Link &rarr;
                </router-link>
              </div>
            </div>

            <!-- Credenciais (sempre visíveis) -->
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block text-xs font-medium text-n-slate-11 mb-1">Pixel ID</label>
                <input
                  v-model="formData.settings.meta_capi.pixel_id"
                  type="text"
                  placeholder="Ex: 123456789012345"
                  class="w-full px-3 py-2 rounded-xl border border-n-weak bg-n-solid-2 text-sm"
                />
              </div>
              <div>
                <label class="block text-xs font-medium text-n-slate-11 mb-1">Access Token</label>
                <input
                  v-model="formData.settings.meta_capi.access_token"
                  type="password"
                  placeholder="EAAxxxxxxx..."
                  class="w-full px-3 py-2 rounded-xl border border-n-weak bg-n-solid-2 text-sm"
                />
              </div>
            </div>

            <div>
              <label class="block text-xs font-medium text-n-slate-11 mb-1">Test Event Code (opcional)</label>
              <input
                v-model="formData.settings.meta_capi.test_event_code"
                type="text"
                placeholder="Deixe vazio para producao"
                class="w-full px-3 py-2 rounded-xl border border-n-weak bg-n-solid-2 text-sm"
              />
            </div>

            <!-- Inboxes vinculadas -->
            <div>
              <label class="block text-xs font-medium text-n-slate-11 mb-1">Inboxes vinculadas</label>
              <p class="text-xs text-n-slate-10 mb-2">
                Eventos CAPI serao disparados apenas para conversas destas
                inboxes. Deixe vazio para todas.
              </p>
              <div class="flex flex-wrap gap-2">
                <button
                  v-for="inbox in inboxes"
                  :key="'capi-inbox-' + inbox.id"
                  type="button"
                  class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-medium border transition-colors"
                  :class="
                    (formData.settings.meta_capi.inbox_ids || []).includes(
                      inbox.id
                    )
                      ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-300 dark:border-blue-700 text-blue-700 dark:text-blue-300'
                      : 'bg-n-solid-2 border-n-weak text-n-slate-11 hover:border-n-weak'
                  "
                  @click="toggleCapiInbox(inbox.id)"
                >
                  <span
                    class="w-2 h-2 rounded-full flex-shrink-0"
                    :class="
                      (formData.settings.meta_capi.inbox_ids || []).includes(
                        inbox.id
                      )
                        ? 'bg-blue-500'
                        : 'bg-n-alpha-3'
                    "
                  />
                  {{ inbox.name }}
                </button>
              </div>
            </div>

            <!-- Origens de leads -->
            <div>
              <label class="block text-sm font-medium text-n-slate-12 mb-3">Origens de Leads</label>
              <p class="text-xs text-n-slate-11 mb-3">
                Selecione de onde vem os leads deste funil. A atribuicao de
                conversao sera feita automaticamente conforme a origem.
              </p>
              <div class="space-y-3">
                <div
                  class="flex items-center gap-3 p-3 rounded-xl border border-n-weak"
                >
                  <label
                    class="relative inline-flex items-center cursor-pointer flex-shrink-0"
                  >
                    <input
                      v-model="formData.settings.meta_capi.source_whatsapp"
                      type="checkbox"
                      class="sr-only peer"
                    />
                    <div
                      class="w-8 h-4 bg-n-alpha-3 peer-checked:bg-green-500 rounded-full transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:after:translate-x-full"
                    />
                  </label>
                  <div class="flex-1">
                    <span class="text-sm font-medium">Click-to-WhatsApp (CTWA)</span>
                    <p class="text-xs text-n-slate-10">
                      Leads de anuncios que direcionam para WhatsApp. Atribuicao
                      via ctwa_clid.
                    </p>
                  </div>
                </div>
                <div
                  class="flex items-center gap-3 p-3 rounded-xl border border-n-weak"
                >
                  <label
                    class="relative inline-flex items-center cursor-pointer flex-shrink-0"
                  >
                    <input
                      v-model="formData.settings.meta_capi.source_leadform"
                      type="checkbox"
                      class="sr-only peer"
                    />
                    <div
                      class="w-8 h-4 bg-n-alpha-3 peer-checked:bg-green-500 rounded-full transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:after:translate-x-full"
                    />
                  </label>
                  <div class="flex-1">
                    <span class="text-sm font-medium">Lead Forms (Formularios)</span>
                    <p class="text-xs text-n-slate-10">
                      Leads de formularios Meta. Atribuicao via leadgen_id
                      enviado na criacao do contato.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- WABA ID - aparece SOMENTE se ha inbox Channel::Whatsapp (Cloud API oficial) selecionada -->
            <div
              v-if="
                formData.settings.meta_capi.source_whatsapp &&
                hasOfficialWhatsappInCapi
              "
            >
              <label class="block text-xs font-medium text-n-slate-11 mb-1">
                WhatsApp Business Account ID (WABA ID)
                <span class="ml-1 text-rose-500 font-normal">- obrigatorio para CTWA via Cloud API</span>
              </label>
              <input
                v-model="formData.settings.meta_capi.waba_id"
                type="text"
                placeholder="Ex: 102345678901234"
                class="w-full px-3 py-2 rounded-xl border border-n-weak bg-n-solid-2 text-sm"
              />
              <p class="text-xs text-n-slate-10 mt-1">
                Detectamos uma inbox
                <strong>WhatsApp Cloud API</strong> (oficial Meta) selecionada
                acima. Pra essas, o Meta exige o WABA ID no payload CTWA.
                <br />Encontre em:
                <a
                  href="https://business.facebook.com/settings/whatsapp-business-accounts"
                  target="_blank"
                  class="text-blue-500 hover:underline"
                  >Meta Business Manager &rarr; Contas &rarr; Contas do
                  WhatsApp</a>.
              </p>
            </div>

            <!-- Page ID - aparece pra inboxes WAHA/Channel::Api (nao-oficial) OU nenhuma whatsapp oficial -->
            <div
              v-if="
                formData.settings.meta_capi.source_whatsapp &&
                hasUnofficialWhatsappInCapi
              "
            >
              <label class="block text-xs font-medium text-n-slate-11 mb-1">
                ID da Pagina do Facebook (Page ID)
                <span class="ml-1 text-rose-500 font-normal">- obrigatorio para CTWA</span>
              </label>
              <input
                v-model="formData.settings.meta_capi.page_id"
                type="text"
                placeholder="Ex: 278821156093684"
                class="w-full px-3 py-2 rounded-xl border border-n-weak bg-n-solid-2 text-sm"
              />
              <p class="text-xs text-n-slate-10 mt-1">
                Pra inboxes
                <strong>WAHA / API nao-oficial</strong> (Channel::Api), o Meta
                aceita o ID da <strong>Pagina do Facebook</strong> que publica
                os anuncios CTWA - nao precisa de WABA. <br />Encontre em:
                <a
                  href="https://business.facebook.com/settings/pages"
                  target="_blank"
                  class="text-blue-500 hover:underline"
                  >Meta Business Manager &rarr; Contas &rarr; Paginas</a>
                - clique na pagina que roda os anuncios e copie o ID.
              </p>
            </div>

            <div>
              <label class="block text-sm font-medium text-n-slate-12 mb-3">Eventos por Estagio</label>
              <p class="text-xs text-n-slate-11 mb-4">
                Configure qual evento CAPI disparar quando um lead entrar em
                cada estagio do funil
              </p>
              <div class="space-y-2">
                <div
                  v-for="(stage, key) in formData.stages"
                  :key="'capi-' + key"
                  class="flex items-center gap-3 p-3 rounded-xl bg-n-solid-2/50"
                >
                  <span
                    class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                    :style="{ backgroundColor: stage.color || '#6B7280' }"
                  />
                  <span class="text-sm font-medium flex-1">{{
                    stage.name
                  }}</span>
                  <select
                    :value="
                      formData.settings.stage_events?.[key]?.event_name || ''
                    "
                    class="px-2 py-1.5 rounded-xl border border-n-weak bg-n-solid-2 text-xs min-w-[180px]"
                    @change="updateStageEvent(key, $event.target.value)"
                  >
                    <option value="">Nenhum evento</option>
                    <option value="Lead">Lead</option>
                    <option value="LeadSubmitted">LeadSubmitted</option>
                    <option value="QualifiedLead">QualifiedLead</option>
                    <option value="ViewContent">ViewContent</option>
                    <option value="AddToCart">AddToCart</option>
                    <option value="InitiateCheckout">InitiateCheckout</option>
                    <option value="Purchase">Purchase</option>
                    <option value="OrderCreated">OrderCreated</option>
                  </select>
                  <label
                    class="relative inline-flex items-center cursor-pointer flex-shrink-0"
                  >
                    <input
                      type="checkbox"
                      :checked="formData.settings.stage_events?.[key]?.enabled"
                      class="sr-only peer"
                      @change="toggleStageEvent(key, $event.target.checked)"
                    />
                    <div
                      class="w-8 h-4 bg-n-alpha-3 peer-checked:bg-green-500 rounded-full transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:after:translate-x-full"
                    />
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- Tab Google Ads (Offline Conversion Upload) -->
      <div v-if="activeFormTab === 'google-ads'">
        <div class="space-y-6">
          <div
            class="flex items-center justify-between p-4 rounded-2xl bg-n-solid-2/50"
          >
            <div>
              <label class="block text-sm font-medium">Conversões Google Ads</label>
              <p class="text-xs text-n-slate-11 mt-0.5">
                Envia conversões automaticamente quando um card avança de
                estágio
              </p>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input
                v-model="formData.settings.google_ads.enabled"
                type="checkbox"
                class="sr-only peer"
              />
              <div
                class="w-9 h-5 bg-n-alpha-3 peer-checked:bg-blue-500 rounded-full transition-colors after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full"
              />
            </label>
          </div>

          <template v-if="formData.settings.google_ads.enabled">
            <!-- Aviso pra usar o Gerador de Link -->
            <div
              class="rounded-xl border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-950/30 p-3 mb-4 flex items-start gap-3"
            >
              <span class="text-xl">&#128279;</span>
              <div class="flex-1 text-xs">
                <b class="block text-sm mb-0.5">Pra capturar gclid em novos leads</b>
                <span class="text-n-slate-11">Crie um capturador no Gerador de Link e use a URL como Final
                  URL do anuncio Google Ads ou em forms.</span>
                <router-link
                  :to="{ name: 'settings_integrations_lead_capture' }"
                  class="block mt-1 text-blue-600 dark:text-blue-400 font-medium"
                >
                  Abrir Gerador de Link &rarr;
                </router-link>
              </div>
            </div>
            <div class="rounded-xl border border-n-weak p-4 space-y-3">
              <div>
                <label class="block text-xs font-medium text-n-slate-11 mb-1">ID da conta</label>
                <input
                  v-model="formData.settings.google_ads.customer_id"
                  type="text"
                  placeholder="Ex: 4138916545"
                  class="w-full px-3 py-2 rounded-xl border border-n-weak bg-n-solid-2 text-sm"
                />
              </div>
            </div>
            <div>
              <label class="block text-xs font-medium text-n-slate-11 mb-1">Inboxes vinculadas</label>
              <p class="text-xs text-n-slate-10 mb-2">
                Deixe vazio para aplicar em todas.
              </p>
              <div class="flex flex-wrap gap-2">
                <button
                  v-for="inbox in inboxes"
                  :key="'gads-inbox-' + inbox.id"
                  type="button"
                  class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-medium border transition-colors"
                  :class="
                    (formData.settings.google_ads.inbox_ids || []).includes(
                      inbox.id
                    )
                      ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-300 dark:border-blue-700 text-blue-700 dark:text-blue-300'
                      : 'bg-n-solid-2 border-n-weak text-n-slate-11 hover:border-n-weak'
                  "
                  @click="toggleGoogleAdsInbox(inbox.id)"
                >
                  <span
                    class="w-2 h-2 rounded-full flex-shrink-0"
                    :class="
                      (formData.settings.google_ads.inbox_ids || []).includes(
                        inbox.id
                      )
                        ? 'bg-blue-500'
                        : 'bg-n-alpha-3'
                    "
                  />
                  {{ inbox.name }}
                </button>
              </div>
            </div>
            <div>
              <label class="block text-sm font-medium text-n-slate-12 mb-3">Eventos por Estágio</label>
              <p class="text-xs text-n-slate-11 mb-4">
                Qual evento de conversão disparar ao avançar para cada estágio.
              </p>
              <div class="space-y-2">
                <div
                  v-for="(stage, key) in formData.stages"
                  :key="'gads-' + key"
                  class="flex items-center gap-3 p-3 rounded-xl bg-n-solid-2/50"
                >
                  <span
                    class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                    :style="{
                      backgroundColor:
                        (typeof stage === 'object' ? stage.color : null) ||
                        '#6B7280',
                    }"
                  />
                  <span
                    class="text-sm font-medium text-n-slate-12 flex-1 min-w-[120px]"
                    >{{
                      (typeof stage === 'object' ? stage.name : stage) ||
                      'Etapa ' + key
                    }}</span>
                  <input
                    type="text"
                    :value="
                      formData.settings.google_ads_stage_events?.[key]
                        ?.conversion_action_id || ''
                    "
                    placeholder="ID do evento"
                    class="px-2 py-1.5 rounded-xl border border-n-weak bg-n-solid-2 text-xs w-44 tabular-nums"
                    @change="updateGoogleAdsStage(key, $event.target.value)"
                  />
                  <label
                    class="inline-flex items-center gap-1 cursor-pointer text-xs text-n-slate-11"
                    title="Enviar o valor do deal junto com a conversão"
                  >
                    <input
                      type="checkbox"
                      :checked="
                        formData.settings.google_ads_stage_events?.[key]
                          ?.send_value
                      "
                      class="rounded border-n-weak"
                      @change="toggleGoogleAdsValue(key, $event.target.checked)"
                    />
                    valor
                  </label>
                  <label
                    class="relative inline-flex items-center cursor-pointer flex-shrink-0"
                  >
                    <input
                      type="checkbox"
                      :checked="
                        formData.settings.google_ads_stage_events?.[key]
                          ?.enabled
                      "
                      class="sr-only peer"
                      @change="toggleGoogleAdsStage(key, $event.target.checked)"
                    />
                    <div
                      class="w-8 h-4 bg-n-alpha-3 peer-checked:bg-green-500 rounded-full transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:after:translate-x-full"
                    />
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- Tab Google Calendar -->
      <div v-if="activeFormTab === 'google-calendar'">
        <div class="space-y-6">
          <div class="p-4 rounded-2xl bg-n-solid-2/50">
            <label class="block text-sm font-medium mb-2">Sincronização com Google Calendar</label>
            <p class="text-xs text-n-slate-11 mb-4">
              Conecte uma agenda Google a este funil. Agendamentos criados em
              conversas que tiverem cards neste funil serão espelhados
              automaticamente. Útil para multi-profissionais — cada funil pode
              ter sua própria agenda.
            </p>
            <FunnelGoogleCalendarSection
              v-if="funnelId || (initialData && initialData.id)"
              :funnel-id="funnelId || initialData.id"
              :funnel-name="
                formData.name || (initialData && initialData.name) || 'Funil'
              "
            />
            <p v-else class="text-sm text-n-slate-11 italic">
              Salve o funil primeiro para conectar uma agenda.
            </p>
          </div>
        </div>
      </div>

      <!-- Tab Auto-Criacao IA -->
      <div v-if="activeFormTab === 'ai-auto-create'">
        <div class="border border-n-weak rounded-xl p-4 space-y-6">
          <!-- Toggle ativar -->
          <div>
            <div class="flex items-center justify-between">
              <div>
                <label class="block text-sm font-medium">Auto-Criacao via IA</label>
                <p class="text-xs text-n-slate-11 mt-0.5">
                  Permite criar itens no kanban automaticamente a partir do
                  historico da conversa usando IA.
                </p>
              </div>
              <Switch
                v-model="formData.settings.ai_auto_create.enabled"
                size="small"
              />
            </div>
          </div>

          <template v-if="formData.settings.ai_auto_create.enabled">
            <!-- Etapa inicial -->
            <div>
              <label class="block text-sm font-medium mb-2">Etapa inicial do item</label>
              <!-- SiteUp: modo da etapa — fixa (dropdown) ou a IA decide (prompt de roteamento) -->
              <div class="flex flex-col gap-2 mb-3 sm:flex-row">
                <label
                  class="flex flex-1 cursor-pointer items-start gap-2 rounded-xl border p-2"
                  :class="
                    (formData.settings.ai_auto_create.stage_mode || 'fixed') !==
                    'ai'
                      ? 'border-woot-500 bg-woot-50 dark:bg-woot-900/20'
                      : 'border-n-weak'
                  "
                >
                  <input
                    v-model="formData.settings.ai_auto_create.stage_mode"
                    type="radio"
                    value="fixed"
                    class="mt-0.5"
                  />
                  <span>
                    <span class="text-sm font-medium">Sempre a mesma etapa</span>
                    <span class="block text-xs text-n-slate-11">O card entra sempre na etapa que voce escolher.</span>
                  </span>
                </label>
                <label
                  class="flex flex-1 cursor-pointer items-start gap-2 rounded-xl border p-2"
                  :class="
                    formData.settings.ai_auto_create.stage_mode === 'ai'
                      ? 'border-woot-500 bg-woot-50 dark:bg-woot-900/20'
                      : 'border-n-weak'
                  "
                >
                  <input
                    v-model="formData.settings.ai_auto_create.stage_mode"
                    type="radio"
                    value="ai"
                    class="mt-0.5"
                  />
                  <span>
                    <span class="text-sm font-medium">Deixar a IA decidir</span>
                    <span class="block text-xs text-n-slate-11">A IA escolhe a etapa com base na conversa.</span>
                  </span>
                </label>
              </div>

              <!-- Modo fixo: dropdown da etapa -->
              <template
                v-if="
                  (formData.settings.ai_auto_create.stage_mode || 'fixed') !==
                  'ai'
                "
              >
                <select
                  v-model="formData.settings.ai_auto_create.default_stage"
                  class="w-full px-3 py-2 border rounded-xl text-sm"
                >
                  <option :value="null">Primeira etapa do funil</option>
                  <option
                    v-for="stage in stages"
                    :key="stage.id"
                    :value="stage.id"
                  >
                    {{ stage.name }}
                  </option>
                </select>
                <p class="text-xs text-n-slate-11 mt-1">
                  Em qual etapa o item sera criado. Se nao selecionado, usa a
                  primeira.
                </p>
              </template>

              <!-- Modo IA: prompt de roteamento -->
              <template v-else>
                <textarea
                  v-model="
                    formData.settings.ai_auto_create.stage_routing_prompt
                  "
                  class="w-full px-3 py-2 border rounded-xl text-sm"
                  rows="4"
                  placeholder="Ex: Se o lead pede orcamento ou tem interesse claro, va para 'Qualificado'. Se so pediu informacao, deixe em 'Interessado'. Se ja fechou, va para 'Venda'."
                />
                <p class="text-xs text-n-slate-11 mt-1">
                  Explique para a IA onde colocar cada lead. Se ela ficar em
                  duvida, usa a primeira etapa.
                </p>
              </template>
            </div>

            <!-- Campos para extrair -->
            <div>
              <label class="block text-sm font-medium mb-3">Campos para preencher automaticamente</label>
              <div class="space-y-2">
                <div
                  v-for="field in [
                    {
                      key: 'title',
                      label: 'Titulo do card',
                      desc: 'Gera titulo descritivo baseado na conversa',
                    },
                    {
                      key: 'description',
                      label: 'Descricao / Resumo',
                      desc: 'Resume os pontos principais da conversa',
                    },
                    {
                      key: 'priority',
                      label: 'Prioridade',
                      desc: 'Detecta urgencia (alta/media/baixa)',
                    },
                    {
                      key: 'value',
                      label: 'Valor estimado',
                      desc: 'Extrai valor monetario mencionado na conversa',
                    },
                  ]"
                  :key="field.key"
                  class="flex items-center gap-3 p-2 rounded-xl hover:bg-n-alpha-2/50 transition-colors"
                >
                  <button
                    type="button"
                    class="flex size-5 shrink-0 items-center justify-center rounded transition-colors"
                    :class="
                      formData.settings.ai_auto_create.extract_fields[field.key]
                        ? 'bg-woot-500 text-white'
                        : 'border border-n-weak bg-n-solid-2'
                    "
                    @click="
                      formData.settings.ai_auto_create.extract_fields[
                        field.key
                      ] =
                        !formData.settings.ai_auto_create.extract_fields[
                          field.key
                        ]
                    "
                  >
                    <span
                      v-if="
                        formData.settings.ai_auto_create.extract_fields[
                          field.key
                        ]
                      "
                      class="text-xs"
                      >&#10003;</span>
                  </button>
                  <div>
                    <span class="text-sm font-medium">{{ field.label }}</span>
                    <p class="text-xs text-n-slate-11">{{ field.desc }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Prompt customizado -->
            <div>
              <label class="block text-sm font-medium mb-2">
                Instrucoes especificas para extracao
              </label>
              <textarea
                v-model="formData.settings.ai_auto_create.custom_prompt"
                class="w-full px-3 py-2 border rounded-xl text-sm"
                rows="4"
                placeholder="Ex: Sempre extrair o nome do empreendimento mencionado. Se o cliente mencionar compra imediata, marcar prioridade alta. Extrair metragem e numero de quartos quando disponivel."
              />
              <p class="text-xs text-n-slate-11 mt-1">
                Instrucoes adicionais para a IA saber o que extrair da conversa.
                Quanto mais especifico, melhor o resultado.
              </p>
            </div>

            <!-- SiteUp: anexar ofertas + comportamento do "Atualizar com IA" -->
            <div class="space-y-3 pt-1">
              <label class="flex items-start gap-2 cursor-pointer">
                <input
                  v-model="formData.settings.ai_auto_create.attach_offers"
                  type="checkbox"
                  class="mt-0.5"
                />
                <span>
                  <span class="text-sm font-medium">Anexar ofertas da conta</span>
                  <p class="text-xs text-n-slate-11">
                    A IA recebe o catalogo de ofertas e anexa ao card so as que
                    aparecerem na conversa (por nome ou link). Se nenhuma
                    combinar, nao anexa nada.
                  </p>
                </span>
              </label>
              <label class="flex items-start gap-2 cursor-pointer">
                <input
                  v-model="
                    formData.settings.ai_auto_create.update_reroute_stage
                  "
                  type="checkbox"
                  class="mt-0.5"
                />
                <span>
                  <span class="text-sm font-medium">Ao "Atualizar com IA", deixar a IA re-decidir a etapa</span>
                  <p class="text-xs text-n-slate-11">
                    Padrao: atualizar refresca os campos
                    (titulo/descricao/prioridade/valor/ofertas) e MANTEM a
                    etapa, o agente, o checklist e as notas. Ative para a IA
                    tambem poder mover o card de etapa (so no modo de etapa por
                    IA).
                  </p>
                </span>
              </label>

              <!-- Autoatualização por inatividade -->
              <div class="rounded-xl border border-n-weak p-3 space-y-3">
                <label class="flex items-start gap-2 cursor-pointer">
                  <input
                    v-model="
                      formData.settings.ai_auto_create.auto_update_enabled
                    "
                    type="checkbox"
                    class="mt-0.5"
                  />
                  <span>
                    <span class="text-sm font-medium">
                      {{ t('KANBAN.FUNNELS.FORM.AI_AUTO_UPDATE.LABEL') }}
                    </span>
                    <p class="text-xs text-n-slate-11">
                      {{ t('KANBAN.FUNNELS.FORM.AI_AUTO_UPDATE.DESCRIPTION') }}
                    </p>
                  </span>
                </label>
                <div
                  v-if="formData.settings.ai_auto_create.auto_update_enabled"
                  class="pl-6"
                >
                  <label class="block text-sm font-medium mb-1">
                    {{ t('KANBAN.FUNNELS.FORM.AI_AUTO_UPDATE.HOURS_LABEL') }}
                  </label>
                  <input
                    v-model.number="
                      formData.settings.ai_auto_create.auto_update_after_hours
                    "
                    type="number"
                    min="1"
                    max="168"
                    step="1"
                    class="w-32 px-3 py-2 border rounded-xl text-sm"
                    @blur="clampAutoUpdateHours"
                  />
                  <p class="text-xs text-n-slate-11 mt-1">
                    {{ t('KANBAN.FUNNELS.FORM.AI_AUTO_UPDATE.HOURS_HELP') }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.border-woot {
  border-color: var(--color-woot);
  border-width: 1px;
}

.ghost-card {
  opacity: 0.5;
  background: #c8ebfb;
}

.cursor-move {
  cursor: move;
}

.loading-spinner {
  @apply w-6 h-6 border-2 border-n-weak border-t-woot-500 rounded-full animate-spin;
}

.agent-card {
  @apply transition-all duration-200;

  &:hover {
    @apply transform scale-[1.02];
  }
}

// Oculta a scrollbar mas permite scroll
.scrollbar-hide {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE 10+ */
}
.scrollbar-hide::-webkit-scrollbar {
  display: none !important; /* Chrome/Safari/Webkit */
}

/* Força ocultar scrollbar em todos os elementos */
.funnel-form {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
.funnel-form::-webkit-scrollbar {
  display: none !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  max-height: 500px;
}
.stage-preview-card {
  position: relative;
}
.stage-preview-card {
  background: var(--tw-bg-opacity, 1) var(--tw-gradient, none);
}
.stage-preview-card:hover {
  background: var(--tw-gradient);
}
.stage-preview-details {
  /* Remove bg e gradiente daqui, fica só no card externo */
}

// Estilos para as abas
.tabs-container {
  margin-bottom: 1rem;
}

.tab-button.tab-active {
  @apply text-woot-500;
}

.tab-button.tab-active::after {
  content: '';
  @apply absolute bottom-0 left-0 right-0 h-0.5 bg-woot-500;
}

.tab-button.tab-inactive {
  @apply hover:text-n-slate-12;
}

.tab-inactive:hover {
  color: #64748b;
}

.dark .tab-inactive {
  color: #94a3b8;
}

.dark .tab-inactive:hover {
  color: #64748b;
}

/* Estilos para as abas com scroll lateral */
.tabs-container {
  overflow: hidden;
}

.tabs-scroll-wrapper {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scroll-behavior: smooth;
}

.tabs-scroll-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.tab-button {
  @apply px-4 py-2 text-sm font-medium relative transition-colors whitespace-nowrap;
}

/* Mobile: ajustes específicos para abas */
@media (max-width: 768px) {
  .tab-button {
    @apply px-3 py-2 text-xs;
  }

  .tabs-scroll-wrapper {
    padding-bottom: 2px; /* Espaço para o scroll */
  }
}

// Estilos para o colapso vertical do grupo Dados Básicos
.collapsible-content {
  transition: all 0.3s ease-in-out;
}

// Classe para limitar linhas de texto
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

/* Preset checklist list — aligned with KanbanChecklistTab.vue */
.preset-checklist-section {
  @apply space-y-2;
}

.preset-checklist-item {
  @apply bg-n-solid-2 rounded-xl p-4 border border-n-weak
    hover:border-n-strong transition-all duration-200;
}

.preset-checklist-text {
  @apply flex-1 text-n-slate-12 text-sm leading-relaxed break-words overflow-hidden;
}

.preset-checklist-metadata {
  @apply text-xs text-n-slate-11;
}

.preset-checklist-priority {
  @apply flex-shrink-0;
}

@media (max-width: 640px) {
  .preset-checklist-item {
    @apply p-3;
  }
}
</style>
